/* eslint-disable */

// @ts-nocheck
import React from 'react';
import { useRouterEvents } from '@/core/features/router/router-events';

export default function WireframeJsAssetDesktop(props: { layoutId: string | null; deviceoutput: string }) {
    const routerEvents = useRouterEvents();

    React.useEffect(() => {
        if (window.isWireframeLoaded) {
            // prevent double initialization
            return;
        }

        const isCheck24Test = window.location.host.includes('check24-test.de');
        window.CHECK24_HOST = isCheck24Test ? 'check24-test.de' : 'check24.de';
        undefined;

        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                var el = this;

                do {
                    if (Element.prototype.matches.call(el, s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }

        window.Check24 = window.Check24 || {};

        window.Check24 = {
            domain: '',
            vars: [],
            delays: [],
            chattyOpen: false,
            set: function (name, value) {
                this.vars[name] = value;
            },
            get: function (name) {
                return this.vars[name];
            },
            setDomain: function (domain) {
                this.set('domain', domain);
            },
            getDomain: function () {
                return typeof this.get('domain') != 'undefined' ? this.get('domain') : 'check24.de';
            },
            getSubDomain: function () {
                return typeof this.get('domain_sub') != 'undefined' ? this.get('domain_sub') : 'www';
            },
            setHost: function (host) {
                var hostParts = host.split('.');
                var domain = host;
                var subDomain = 'www';
                if (hostParts.length > 2) {
                    domain = hostParts.slice(hostParts.length - 2, hostParts.length).join('.');
                    subDomain = hostParts.slice(0, hostParts.length - 2).join('.');
                }
                this.set('domain', domain);
                this.set('domain_sub', subDomain);
            },
            getHost: function () {
                return this.getSubDomain() + '.' + this.getDomain();
            },
            include: function (src, id) {
                var script = document.createElement('script');
                script.src = src;
                script.type = 'text/javascript';
                script.defer = true;
                if (id) script.id = id;

                var head = document.getElementsByTagName('head').item(0);
                head.appendChild(script);
            },
            isTouchDevice: function () {
                var maxTouch = typeof navigator.maxTouchPoints != 'undefined' ? navigator.maxTouchPoints : 0;
                var maxTouchMs = typeof navigator.msMaxTouchPoints != 'undefined' ? navigator.msMaxTouchPoints : 0;
                return 'ontouchstart' in window || maxTouch > 0 || maxTouchMs > 0;
            },
            microtime: function (get_as_float) {
                var now = new Date().getTime() / 1000;
                var s = parseInt(now, 10);
                return get_as_float ? now : Math.round((now - s) * 1000) / 1000 + ' ' + s;
            },
            isObject: function (obj) {
                return obj === Object(obj);
            },
            isNumeric: function (n) {
                return !isNaN(parseFloat(n)) && isFinite(n);
            },
            htmlEntities: function (str) {
                return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
            },
            queryString: function () {
                var query_string = {};
                var decoder = function (uriString) {
                    try {
                        return decodeURIComponent(uriString);
                    } catch (e) {
                        return uriString;
                    }
                };
                var query = window.location.search.substring(1);
                var vars = query.split('&');
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split('=');
                    // If first entry with this name
                    if (typeof query_string[pair[0]] === 'undefined') {
                        query_string[pair[0]] = decoder(pair[1]);
                        // If second entry with this name
                    } else if (typeof query_string[pair[0]] === 'string') {
                        query_string[pair[0]] = [query_string[pair[0]], decoder(pair[1])];
                        // If third or later entry with this name
                    } else {
                        query_string[pair[0]].push(decoder(pair[1]));
                    }
                }
                return query_string;
            },
            urlWithQueryParams: function (url, keyValuePairs) {
                var anchor = document.createElement('a');
                anchor.href = url;
                var kvp = anchor.search === '' ? [] : anchor.search.substr(1).split('&');
                var k;
                for (k in keyValuePairs) {
                    var key = encodeURIComponent(k);
                    var value = encodeURIComponent(keyValuePairs[k]);
                    var i = 0;
                    for (; i < kvp.length; i++) {
                        if (kvp[i].startsWith(key + '=')) {
                            var pair = kvp[i].split('=');
                            pair[1] = value;
                            kvp[i] = pair.join('=');
                            break;
                        }
                    }
                    if (i >= kvp.length) {
                        kvp[kvp.length] = [key, value].join('=');
                    }
                }
                anchor.search = kvp.join('&');
                return anchor.href;
            },
            setCookie: function (cookieName, value, duration) {
                if (cookieName && value && duration) {
                    var date = new Date();
                    date.setTime(date.getTime() + duration);
                    document.cookie =
                        cookieName +
                        '=' +
                        value +
                        '; expires=' +
                        date.toGMTString() +
                        '; path=/; domain=' +
                        window.Check24.getDomain() +
                        '; SameSite=lax';
                }
            },
            getCookie: function (cookieName) {
                if (cookieName) {
                    var value = '; ' + document.cookie;
                    var parts = value.split('; ' + cookieName + '=');
                    if (parts.length === 2) {
                        return parts.pop().split(';').shift();
                    } else {
                        return '';
                    }
                }
            },
            hasClass: function (ele, className) {
                var el = document.querySelector(ele);
                if (el) {
                    if (el.classList) {
                        return el.classList.contains(className);
                    } else {
                        return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
                    }
                }
            },
            addClass: function addClass(element, className) {
                var ele = document.querySelectorAll(element);

                if (ele) {
                    ele.forEach(function (el) {
                        if (el.classList) {
                            el.classList.add(className);
                        } else if (!window.Check24.hasClass(el, className)) {
                            el.className += ' ' + className;
                        }
                    });
                }
            },
            removeClass: function removeClass(element, className) {
                var ele = document.querySelectorAll(element);

                if (ele) {
                    ele.forEach(function (el) {
                        if (el.classList) {
                            el.classList.remove(className);
                        } else if (window.Check24.hasClass(el, className)) {
                            var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                            el.className = el.className.replace(reg, ' ');
                        }
                    });
                }
            },
            show: function (element, mode) {
                if (Array.isArray(element)) {
                    element.forEach(function (elem) {
                        var ele = document.querySelectorAll(elem);
                        ele.forEach(function (el) {
                            if (el) {
                                if (mode) {
                                    if (mode === 'visibility') {
                                        el.style.visibility = 'visible';
                                    } else {
                                        el.style.display = mode;
                                    }
                                } else {
                                    el.style.display = 'block';
                                }
                            }
                        });
                    });
                } else {
                    var ele = document.querySelectorAll(element);
                    ele.forEach(function (el) {
                        if (mode) {
                            if (mode === 'visibility') {
                                el.style.visibility = 'visible';
                            } else {
                                el.style.display = mode;
                            }
                        } else {
                            el.style.display = 'block';
                        }
                    });
                }
            },
            hide: function (element, mode) {
                if (Array.isArray(element)) {
                    element.forEach(function (elem) {
                        var ele = document.querySelectorAll(elem);
                        ele.forEach(function (el) {
                            if (el) {
                                if (mode === 'visibility') {
                                    el.style.visibility = 'hidden';
                                } else {
                                    el.style.display = 'none';
                                }
                            }
                        });
                    });
                } else {
                    var ele = document.querySelectorAll(element);
                    ele.forEach(function (el) {
                        if (el) {
                            if (mode === 'visibility') {
                                el.style.visibility = 'hidden';
                            } else {
                                el.style.display = 'none';
                            }
                        }
                    });
                }
            },
            exists: function (element) {
                return document.body.contains(document.querySelector(element));
            },
            closest: function closest(area, element) {
                return document.querySelector(area).closest(element);
            },
            find: function find(area, element, single) {
                // Final found elements
                var found_elements = [];
                var outers = area; // Find all the outer matched elements
                if (single === true) {
                    found_elements = outers.querySelector(element);
                } else {
                    outers = document.querySelectorAll(area);
                    for (var i = 0; i < outers.length; i++) {
                        var elements_in_outer = outers[i].querySelectorAll(element);
                        elements_in_outer = Array.prototype.slice.call(elements_in_outer);
                        found_elements = found_elements.concat(elements_in_outer);
                    }
                }
                return found_elements;
            },
            addEvent: function addEvent(ele, event, callback) {
                if (typeof callback !== 'function') {
                    return false;
                }

                if (ele.indexOf(/\./)) {
                    var className = document.querySelectorAll(ele);

                    for (var i = 0; i < className.length; i++) {
                        className[i].removeEventListener(event, callback, false);
                        className[i].addEventListener(event, callback, false);
                    }
                } else if (ele.indexOf('#')) {
                    document.querySelector(ele).removeEventListener(event, callback, false);
                    document.querySelector(ele).addEventListener(event, callback, false);
                } else {
                }
            },
            removeEvent: function removeEvent(element, event, callback) {
                var el = document.querySelector(element);
                if (el && event && callback) {
                    el.removeEventListener(event, callback, false);
                } else {
                }
            },
            getValue: function getValue(element) {
                var ele = document.querySelector(element);

                if (ele) {
                    return ele.value;
                }
            },
            change: function change(type, element, value, callback) {
                var ele = document.querySelectorAll(element);
                if (element.indexOf(/\./)) {
                    ele.forEach(function (el) {
                        if (el) {
                            if (type === 'value') {
                                el.value = value;
                            } else if (type === 'html') {
                                el.innerHTML = value;
                            } else if (type === 'type') {
                                el.type = value;
                            } else if (type === 'placeholder') {
                                el.placeholder = value;
                            } else if (type === 'href') {
                                el.href = value;
                            } else {
                            }
                        }
                    });
                } else {
                    ele = document.querySelector(element);
                    if (type === 'value') {
                        ele.value = value;
                    } else if (type === 'html') {
                        ele.innerHTML = value;
                    } else if (type === 'type') {
                        ele.type = value;
                    } else if (type === 'placeholder') {
                        ele.placeholder = value;
                    } else if (type === 'href') {
                        ele.href = value;
                    } else {
                    }
                }

                if (typeof callback === 'function') {
                    callback();
                }
            },
            hover: {
                hoverEle: '',
                layerEle: '',
                timer: '',
                callbackEnter: function () {},
                callbackLeave: function () {},
                init: function (hoverEle, layerEle, callbackEnter, callbackLeave, timeOut) {
                    var timeout = timeOut ? timeOut : 0,
                        hovers = document.querySelectorAll(hoverEle);

                    hovers.forEach(function (hover) {
                        hover.removeEventListener(
                            'mouseenter',
                            function (e) {
                                window.Check24.hover.enter(e, hoverEle, layerEle, callbackEnter, timeout);
                            },
                            false,
                        );
                        hover.addEventListener(
                            'mouseenter',
                            function (e) {
                                window.Check24.hover.enter(e, hoverEle, layerEle, callbackEnter, timeout);
                            },
                            false,
                        );
                        hover.removeEventListener(
                            'touchend',
                            function (e) {
                                window.Check24.hover.enter(e, hoverEle, layerEle, callbackEnter, timeout);
                            },
                            false,
                        );
                        hover.addEventListener(
                            'touchend',
                            function (e) {
                                window.Check24.hover.enter(e, hoverEle, layerEle, callbackEnter, timeout);
                            },
                            false,
                        );
                        hover.removeEventListener(
                            'mouseleave',
                            function (e) {
                                window.Check24.hover.leave(e, hoverEle, layerEle, callbackLeave);
                            },
                            false,
                        );
                        hover.addEventListener(
                            'mouseleave',
                            function (e) {
                                window.Check24.hover.leave(e, hoverEle, layerEle, callbackLeave);
                            },
                            false,
                        );
                    });
                    document.removeEventListener(
                        'mouseup',
                        function (e) {
                            window.Check24.hover.leaveDoc(e, hoverEle, layerEle, callbackLeave);
                        },
                        false,
                    );
                    window.addEventListener(
                        'mouseup',
                        function (e) {
                            window.Check24.hover.leaveDoc(e, hoverEle, layerEle, callbackLeave);
                        },
                        false,
                    );
                    document.removeEventListener(
                        'touchend',
                        function (e) {
                            window.Check24.hover.leaveDoc(e, hoverEle, layerEle, callbackLeave);
                        },
                        false,
                    );
                    window.addEventListener(
                        'touchend',
                        function (e) {
                            window.Check24.hover.leaveDoc(e, hoverEle, layerEle, callbackLeave);
                        },
                        false,
                    );
                },
                enter: function (e, hoverEle, layerEle, callback, timeout) {
                    if (
                        hoverEle === '.c24-contact' &&
                        typeof window.Check24.contact !== 'undefined' &&
                        !window.Check24.contact.isContactLayerEnabled
                    ) {
                        return;
                    }
                    var entered = e.target,
                        eleOuter = entered.closest(hoverEle),
                        eleInner = entered.querySelector(hoverEle),
                        isHoverEle = entered.classList && entered.classList.contains(hoverEle),
                        currentEle =
                            eleOuter !== null ? eleOuter : eleInner !== null ? eleInner : isHoverEle ? e.target : null;

                    if (
                        typeof window.Check24.hitsSearch !== 'undefined' &&
                        typeof window.Check24.hitsSearch.removeOverlay === 'function'
                    ) {
                        window.Check24.hitsSearch.removeOverlay();
                    }

                    if (currentEle !== null && currentEle.classList && !currentEle.classList.contains('open')) {
                        e.target.nodeName === 'A' ? e.preventDefault() : {};
                        window.Check24.hover.timer = setTimeout(function () {
                            window.Check24.removeClass(hoverEle, 'open');
                            currentEle.classList.add('open');
                            var currentLayerEle = currentEle.querySelector(layerEle);
                            currentLayerEle.style.visibility = 'visible';
                        }, timeout);
                    }

                    if (typeof callback == 'function') {
                        callback(currentEle);
                    }
                },
                leave: function (e, hoverEle, layerEle, callback) {
                    clearTimeout(window.Check24.hover.timer);

                    window.Check24.removeClass(hoverEle, 'open');

                    var layerEles = document.querySelectorAll(layerEle);
                    layerEles.forEach(function (layer) {
                        layer.style.visibility = 'hidden';
                    });

                    if (typeof callback == 'function') {
                        callback(hoverEle);
                    }
                },
                leaveDoc: function (e, hoverEle, layerEle, callback) {
                    var clicked = e.target;

                    if (typeof clicked.closest == 'function' && clicked.closest(hoverEle) === null) {
                        window.Check24.removeClass(hoverEle, 'open');

                        var layerEles = document.querySelectorAll(layerEle);
                        layerEles.forEach(function (layer) {
                            if (layer.classList && !layer.classList.contains('c24-ignore-dc-event')) {
                                layer.style.visibility = 'hidden';
                            }
                        });
                    }

                    if (typeof callback == 'function') {
                        callback();
                    }
                },
            },
            popup: function () {
                var w = arguments[0] ? arguments[0] : '580';
                var h = arguments[1] ? arguments[1] : '360';
                var u = arguments[2] ? arguments[2] : '';
                var popup = window.open(
                    u,
                    'popup',
                    'width=' +
                        w +
                        ',height=' +
                        h +
                        ',scrollbars=yes, toolbar=no,status=no,resizable=yes,menubar=no,location=no,directories=no,top=10,left=10',
                );
                if (popup) popup.focus();
            },
            useTracking: true,
            asset42: function () {
                if (window.Check24.useTracking) {
                    try {
                        var query = window.location.search,
                            request = new XMLHttpRequest();
                        request.open('GET', 'https://asset42.check24.de/files/give_png.php' + query, true);
                        request.withCredentials = true;
                        request.send();
                    } catch (e) {}
                }
            },
            setTabIndexes: function () {
                var navEles = document.querySelectorAll('.c24-nav-ele-title');
                navEles.forEach(function (ele) {
                    ele.setAttribute('tabindex', '0');
                });
                var subnavEles = document.querySelectorAll('.c24-subnav a');
                subnavEles.forEach(function (ele) {
                    ele.setAttribute('tabindex', '-1');
                });
                var footerEles = document.querySelectorAll('#c24-footer a');
                footerEles.forEach(function (ele) {
                    ele.setAttribute('tabindex', '0');
                });
            },
        };

        window.addEventListener(
            'wireframe-loaded-custom-event',
            function () {
                if (typeof CHECK24_HOST != 'undefined') {
                    window.Check24.setHost(CHECK24_HOST);
                }
                window.Check24.asset42();
                window.Check24.setTabIndexes();
            },
            false,
        );
        window.addEventListener(
            'wireframe-init',
            function () {
                if (typeof CHECK24_HOST != 'undefined') {
                    window.Check24.setHost(CHECK24_HOST);
                }
                window.Check24.setTabIndexes();
            },
            false,
        );

        window.addEventListener('c24-chatty-change-status', function (e) {
            try {
                window.Check24.chattyOpen = e.detail.chatty.status === true;
            } catch (e) {
                window.Check24.chattyOpen = false;
            }
            if (window.Check24.chattyOpen && window.Check24.exists('.c24-contact')) {
                window.Check24.removeClass('.c24-contact', 'open');
                if (window.Check24.exists('.c24-contact-layer')) {
                    document.querySelector('.c24-contact-layer').style.visibility = 'hidden';
                }
            }
        });

        window.addEventListener('c24-chatty-close', function (e) {
            window.Check24.chattyOpen = false;
        });

        if (typeof document !== 'undefined' && document.querySelector('.c24-footer-jumptotop') !== null) {
            document.querySelector('.c24-footer-jumptotop').addEventListener('click', function (e) {
                if (!window.Check24.hasClass('.c24-footer', 'c24-no-event')) {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth',
                    });
                }
            });
        }

        window.Check24 = window.Check24 || {};

        window.Check24.resize = {
            init: function () {
                if (document.documentElement.clientWidth >= 955) {
                    window.Check24.change(
                        'placeholder',
                        '.c24-responsive .c24-search-input',
                        'Was m\u00F6chten Sie vergleichen?',
                    );
                } else {
                    window.Check24.change('placeholder', '.c24-responsive .c24-search-input', 'Suche');
                }
                // Reposition Header Hover Corners
                window.Check24.headerHover.setHoverPos();
            },
        };

        window.Check24.ls = {
            _domain: '.check24.de',
            set: function (product, value) {
                if (typeof value === 'boolean') {
                    var myDate = new Date();
                    var val = window.Check24.getCookie('c24ls');
                    if (value === true) {
                        if (product !== '' && product != null && product !== 'undefined') {
                            if (val) {
                                if (val.indexOf(product) !== -1) {
                                } else {
                                    val = val + ',' + product;
                                }
                            } else {
                                val = product;
                            }
                            myDate.setMonth(myDate.getMonth() + 3);
                            document.cookie =
                                'c24ls=' +
                                val +
                                '; expires=' +
                                myDate +
                                '; domain=' +
                                window.Check24.ls._domain +
                                '; path=/; SameSite=lax';
                        }
                    } else {
                        if (product !== '' && product != null && product !== 'undefined') {
                            if (val && val.indexOf(product) !== -1) {
                                var values = val.split(',');
                                for (var i = 0; i < values.length; i++) {
                                    if (values[i] === product) {
                                        values.splice(i, 1).join(',');
                                    }
                                }
                                myDate.setMonth(myDate.getMonth() + 3);
                                if (values) {
                                    document.cookie =
                                        'c24ls=' +
                                        values +
                                        '; expires=' +
                                        myDate +
                                        '; domain=' +
                                        window.Check24.ls._domain +
                                        '; path=/; SameSite=lax';
                                } else {
                                    document.cookie =
                                        'c24ls=' +
                                        values +
                                        '; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=' +
                                        window.Check24.ls._domain +
                                        '; path=/; SameSite=lax';
                                }
                            }
                        }
                    }
                }
            },
            get: function (product) {
                var val = window.Check24.getCookie('c24ls');
                if (val && product !== '' && product != null && product !== 'undefined') {
                    return val.indexOf(product) > -1;
                }
            },
        };

        var currentWindowWidth = document.documentElement.clientWidth;
        window.addEventListener(
            'resize',
            function () {
                if (document.documentElement.clientWidth !== currentWindowWidth) {
                    currentWindowWidth = document.documentElement.clientWidth;
                    window.Check24.resize.init();
                }
            },
            false,
        );
        window.Check24 = window.Check24 || {};
        window.Check24.BPM = {
            ajax: {},
            data: {},
            timeout: 1000,
            get: function (field, callback, product) {
                var apiProduct = typeof product != 'undefined' ? product : 'website';
                window.Check24.BPM.callbackList.push({
                    field: field,
                    callback: callback,
                    product: product,
                });
                if (typeof window.Check24.BPM.data[apiProduct] == 'undefined') {
                    if (typeof window.Check24.BPM.ajax[apiProduct] == 'undefined') {
                        var request = new XMLHttpRequest();
                        request.open(
                            'GET',
                            '//www.' + window.Check24.getDomain() + '/ajax/bpm/get/?product=' + apiProduct,
                            true,
                        );
                        request.withCredentials = true;
                        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                        request.timeout = window.Check24.BPM.timeout;
                        request.onload = function () {
                            if (this.status >= 200 && this.status < 400) {
                                var json = JSON.parse(this.response);
                                window.Check24.BPM.ajax[apiProduct] = true;
                                window.Check24.BPM.data[apiProduct] = json.data;
                                window.Check24.BPM._callback();
                            }
                        };
                        request.send(null);
                    }
                } else {
                    window.Check24.BPM._callback();
                }
            },
            getAll: function (callback, product) {
                var apiProduct = typeof product != 'undefined' ? product : 'website';
                if (typeof callback == 'function') {
                    window.Check24.BPM.get('_all_', callback, apiProduct);
                } else {
                    throw new Error('callback is not typeof function');
                }
            },
            callbackList: [],
            _callback: function () {
                for (var i = 0; i < window.Check24.BPM.callbackList.length; i++) {
                    var entry = window.Check24.BPM.callbackList[i];
                    if (typeof window.Check24.BPM.data[entry.product] != 'undefined') {
                        window.Check24.BPM.callbackList.splice(i, 1);
                        i--;
                        var val = window.Check24.BPM.data[entry.product][entry.field];
                        if (entry.field === '_all_') {
                            val = window.Check24.BPM.data[entry.product];
                        }
                        if (typeof val == 'undefined') {
                            val = '';
                        }
                        if (typeof entry.callback == 'function') {
                            entry.callback(val);
                        } else {
                            if (typeof val != 'undefined' && val !== '') {
                                var el = document.querySelector(entry.callback);
                                if (
                                    el.getAttribute('type') &&
                                    (el.getAttribute('type') === 'checkbox' || el.getAttribute('type') === 'radio')
                                ) {
                                    el.checked = JSON.parse(val);
                                } else {
                                    el.val(val);
                                }
                            }
                        }
                    }
                }
            },
            __setAjax: null,
            __setList: [],
            set: function (field, value, product) {
                // if no product is set, use default 'website'
                product = typeof product != 'undefined' ? product : 'website';
                // if empty request look at queue
                if (typeof field == 'undefined') {
                    if (window.Check24.BPM.__setList.length === 0) {
                        return;
                    }
                    var request = window.Check24.BPM.__setList.pop();
                    field = request.__field;
                    product = request.product;
                    value = request[field];
                }
                // if set ajax is running, save request
                if (window.Check24.BPM.__setAjax !== null) {
                    data.__field = field;
                    window.Check24.BPM.__setList.push(data);
                } else {
                    // Feld lokal speichern
                    if (typeof window.Check24.BPM.data[product] != 'undefined') {
                        window.Check24.BPM.data[product][field] = value;
                    }
                    // Send set request
                    var request = new XMLHttpRequest();
                    request.open(
                        'GET',
                        '//www.' +
                            window.Check24.getDomain() +
                            '/ajax/bpm/set/?product=' +
                            product +
                            '&' +
                            field +
                            '=' +
                            value,
                        true,
                    );
                    request.withCredentials = true;
                    request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
                    request.timeout = window.Check24.BPM.timeout;
                    request.onload = function () {
                        if (this.status >= 200 && this.status < 400) {
                            window.Check24.BPM.__setAjax = null;
                            // Start again if there is something in the queue
                            window.Check24.BPM.set();
                        } else {
                            // Try next
                            window.Check24.BPM.set();
                        }
                    };
                    request.onerror = function () {
                        // Try next
                        window.Check24.BPM.set();
                    };
                    request.send(null);
                }
            },
        };
        window.Check24 = window.Check24 || {};
        window.Check24.cookieBanner = {
            domain: '.check24.de',
            init: function () {
                // "Legacy case" ("opt-out") for the Spanish products still using the German Wireframe
                // Will be removed once the Spanish products convert to their own Wireframe
                if (document.querySelector('.c24-cookie')) {
                    window.Check24.removeClass('body', 'c24-cc-visible');
                    window.Check24.cookieBanner.initLegacyCookieBanner();
                    return;
                }

                var consentWrapper = document.querySelector('.c24-cookie-consent-wrapper');
                if (consentWrapper == null) {
                    window.Check24.removeClass('body', 'c24-cc-visible');
                    return;
                }

                setTimeout(function checkForLayer() {
                    if (consentWrapper != null) {
                        var layerStyle = window.getComputedStyle(consentWrapper);
                        if (consentWrapper.length === 0 || layerStyle.display === 'none') {
                            window.Check24.removeClass('body', 'c24-cc-visible');
                        } else {
                            setTimeout(checkForLayer, 500);
                        }
                    } else {
                        window.Check24.removeClass('body', 'c24-cc-visible');
                    }
                }, 500);

                // New Cookie Consent Screen case ("opt-in")
                window.Check24.cookieBanner.c24consent.initCookieConsentScreen();
            },
            c24consent: {
                refreshLayout: function () {
                    var consentNotice = document.querySelector('.c24-cookie-consent-notice');
                    var consentScreen = document.querySelector('.c24-cookie-consent-screen');
                    window.Check24.show(['.c24-cookie-consent-screen', '.c24-cookie-consent-notice'], 'flex');
                    if (consentNotice.offsetHeight < consentScreen.offsetHeight) {
                        consentNotice.style.height = consentScreen.offsetHeight + 'px';
                        consentScreen.style.height = consentScreen.offsetHeight + 'px';
                    } else {
                        consentScreen.style.height = consentNotice.offsetHeight + 'px';
                        consentNotice.style.height = consentNotice.offsetHeight + 'px';
                    }
                    window.Check24.hide(['.c24-cookie-consent-screen', '.c24-cookie-consent-notice']);
                },
                /* {initCookieConsentScreen: function () {
            var c24consent = window.Check24.cookieBanner.c24consent.getCookieWithName("c24consent");
            if (c24consent && c24consent.indexOf("t") === -1) {
                // If c24consent cookie is set & not marked as temporary => everything is fine => we do not have to show a cookie consent screen
                // Instead, we refresh the lifetime of the existing cookie
                window.Check24.cookieBanner.c24consent.setC24consentCookie(c24consent);
                return;
            }

            // If user had a c24consent cookie that is marked as "temporary", remove that
            // => we need to ask him for his consent.
            if (c24consent && c24consent.indexOf("t") !== -1) {
                window.Check24.cookieBanner.c24consent.unsetCookie("c24consent");
            }

            // Special case: In case the user previously closed the legacy cookie banner (c24cb=1)
            //               and did not opt-out to anything (ch24oo not set or ch24oo === '00000000000'),
            //               we set the c24consent value to "fam" and do not show the Cookie Consent Screen.
            var c24cb = window.Check24.cookieBanner.c24consent.getCookieWithName("c24cb");
            if (c24cb === "1") {
                var ch24oo = window.Check24.cookieBanner.c24consent.getCookieWithName("ch24oo");
                if (ch24oo === null || ch24oo === "00000000000") {
                    window.Check24.cookieBanner.c24consent.setC24consentCookie("fam");
                    return;
                }
            }

            // Show consent screen notice
            window.Check24.cookieBanner.c24consent.showNoticeScreen();
        },
} */ giveConsent: function (consent) {
                    window.Check24.hide(['.c24-cookie-consent-screen', '.c24-cookie-consent-notice']);
                    window.Check24.removeClass('body', 'c24-cc-visible');

                    window.Check24.cookieBanner.c24consent.setC24consentCookie(consent);
                    window.Check24.cookieBanner.c24consent.countCookieConsent(consent);
                    var consentm = window.Check24.cookieBanner.c24consent.marketingConsent;
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'c24consent',
                            c24consent: consent,
                            c24consentm: consent.indexOf('m') !== -1 ? '' : consentm,
                        });
                    }
                    window.dispatchEvent(
                        new CustomEvent('c24consent', {
                            detail: {
                                c24consent: consent,
                                c24consentm: consent.indexOf('m') !== -1 ? '' : consentm,
                            },
                        }),
                    );
                },
                getC24consentCookieDomain: function () {
                    if (window && window.location && window.location.hostname) {
                        return window.location.hostname.split('.').slice(-2).join('.');
                    }
                    return 'check24.de';
                },
                setC24consentCookie: function (value) {
                    var content = 'c24consent=' + value;
                    var domain = 'domain=.' + window.Check24.cookieBanner.c24consent.getC24consentCookieDomain();
                    var sameSite = 'samesite=lax';
                    var path = 'path=/';

                    var d = new Date();
                    if (value === 'f') {
                        d.setTime(d.getTime() + 604800000); /* seven days in milliseconds */
                    } else {
                        d.setTime(d.getTime() + 63072000000); /* two years in milliseconds */
                    }
                    var expires =
                        'expires=' +
                        d.toUTCString(); /* max-age would have been easier here, but does not work in IE < 10 */

                    document.cookie = [content, domain, path, expires, sameSite, 'secure'].join('; ');
                    if (value === 'fam') {
                        document.cookie = [
                            'c24consentm=',
                            domain,
                            path,
                            'expires=Thu, 01 Jan 1970 00:00:00 UTC',
                            sameSite,
                            'secure',
                        ].join('; ');
                    }
                },
                unsetCookie: function (name) {
                    // Similar to `setC24consentCookie`, but uses a negative expiry time => cookie will be removed
                    var content = name + '=';
                    var domain = 'domain=.' + window.Check24.cookieBanner.c24consent.getC24consentCookieDomain();
                    var sameSite = 'samesite=lax';
                    var path = 'path=/';

                    var d = new Date();
                    d.setTime(d.getTime() - 63072000000); /* two years in milliseconds */
                    var expires =
                        'expires=' +
                        d.toUTCString(); /* max-age would have been easier here, but does not work in IE < 10 */

                    document.cookie = [content, domain, path, expires, sameSite, 'secure'].join('; ');
                },
                showConsentScreen: function () {
                    window.Check24.cookieBanner.c24consent.refreshLayout();
                    window.Check24.hide('.c24-cookie-consent-notice', 'visibility');
                    window.Check24.hide('.c24-cookie-consent-notice');
                    window.Check24.show('.c24-cookie-consent-screen', 'visibility');
                    window.Check24.show('.c24-cookie-consent-screen', 'flex');
                    window.Check24.addClass('body', 'c24-cc-visible');
                },
                hideConsentScreen: function () {
                    window.Check24.hide('.c24-cookie-consent-screen', 'visibility');
                    window.Check24.hide('.c24-cookie-consent-screen');
                    window.Check24.removeClass('body', 'c24-cc-visible');
                },
                showNoticeScreen: function () {
                    window.Check24.cookieBanner.c24consent.refreshLayout();
                    window.Check24.hide('.c24-cookie-consent-screen', 'visibility');
                    window.Check24.hide('.c24-cookie-consent-screen');
                    window.Check24.show('.c24-cookie-consent-notice', 'visibility');
                    window.Check24.show('.c24-cookie-consent-notice', 'flex');
                    window.Check24.addClass('body', 'c24-cc-visible');
                },
                getCookieWithName: function (name) {
                    var cookieArr = document.cookie.split(';');

                    for (var i = 0; i < cookieArr.length; i++) {
                        var cookiePair = cookieArr[i].split('=');

                        if (cookiePair[0].trim() === name) {
                            return cookiePair[1];
                        }
                    }

                    return null;
                },
                toggleDescriptionText: function (id, iconId) {
                    var el = document.getElementById(id);
                    if (!el) {
                        return;
                    }

                    if (el.style.display === 'none' || el.style.display === '') {
                        el.style.display = 'block';
                        window.Check24.addClass('#' + iconId, 'c24-cookie-consent-button-more-icon-open');
                        var wrapper = document.querySelector('.c24-cookie-consent-screen-list');
                        wrapper.scrollTo(0, document.getElementById(iconId).offsetTop - wrapper.offsetTop - 15);
                        return;
                    }

                    el.style.display = 'none';
                    window.Check24.removeClass('#' + iconId, 'c24-cookie-consent-button-more-icon-open');
                },
                toggleCheckbox: function (id) {
                    var checkbox = document.getElementById(id);
                    if (!checkbox) {
                        return;
                    }

                    checkbox.checked = !checkbox.checked;

                    if (id === 'check24-cookie-marketing') {
                        for (var i = 1; i <= 5; i++) {
                            var ele = document.getElementById('check24-cookie-marketing-' + i);
                            if (!ele) {
                                return;
                            }
                            if (checkbox.checked) {
                                ele.checked = true;
                            } else {
                                ele.checked = false;
                            }
                        }
                    }
                    if (checkbox.classList && checkbox.classList.contains('c24-cookie-consent-m-toggle')) {
                        var checkedEles = '';
                        for (var i = 1; i <= 5; i++) {
                            var ele = document.getElementById('check24-cookie-marketing-' + i);
                            if (!ele) {
                                return;
                            }
                            if (ele.checked) {
                                checkedEles += i;
                            }
                        }

                        var mCheckbox = document.getElementById('check24-cookie-marketing');
                        if (checkedEles === '12345') {
                            mCheckbox.checked = true;
                        } else {
                            mCheckbox.checked = false;
                        }
                    }
                },
                updateConsentScreen: function () {
                    var c24consent = window.Check24.cookieBanner.c24consent.getCookieWithName('c24consent');
                    var c24consentm = window.Check24.cookieBanner.c24consent.getCookieWithName('c24consentm');

                    if (c24consent) {
                        var analytics = document.getElementById('check24-cookie-analytics');
                        if (analytics) {
                            analytics.checked = c24consent.indexOf('a') !== -1;
                        }
                        var marketing = document.getElementById('check24-cookie-marketing');
                        if (marketing) {
                            if (c24consent.indexOf('m') !== -1) {
                                for (var i = 1; i <= 5; i++) {
                                    var ele = document.getElementById('check24-cookie-marketing-' + i);
                                    ele.checked = true;
                                }
                            } else {
                                if (c24consentm) {
                                    for (var i = 1; i <= 5; i++) {
                                        var ele = document.getElementById('check24-cookie-marketing-' + i);
                                        ele.checked = c24consentm.indexOf(i) !== -1;
                                    }
                                }
                            }
                            marketing.checked = c24consent.indexOf('m') !== -1;
                        }
                    }
                },
                getConfiguredConsent: function () {
                    var result = 'f';

                    var analytics = document.getElementById('check24-cookie-analytics');
                    if (analytics && analytics.checked) {
                        result += 'a';
                    }
                    var marketing = document.getElementById('check24-cookie-marketing');
                    if (
                        marketing &&
                        marketing.checked &&
                        window.Check24.cookieBanner.c24consent.marketingConsent === '12345'
                    ) {
                        result += 'm';
                    }

                    return result;
                },
                marketingConsent: '',
                giveMarketingConsent: function () {
                    var result = '';
                    for (var i = 1; i <= 5; i++) {
                        var ele = document.getElementById('check24-cookie-marketing-' + i);
                        if (ele && ele.checked) {
                            result += i;
                        }
                    }
                    window.Check24.cookieBanner.c24consent.marketingConsent = result;
                    var content = 'c24consentm=' + result;
                    var domain = 'domain=.' + window.Check24.cookieBanner.c24consent.getC24consentCookieDomain();
                    var sameSite = 'samesite=lax';
                    var path = 'path=/';
                    var d = new Date();
                    d.setTime(d.getTime() + 63072000000);
                    var expires = 'expires=' + d.toUTCString();

                    if (result !== '' && result !== '12345') {
                        document.cookie = [content, domain, path, expires, sameSite, 'secure'].join('; ');
                    } else {
                        document.cookie = [
                            'c24consentm=',
                            domain,
                            path,
                            'expires=Thu, 01 Jan 1970 00:00:00 UTC',
                            sameSite,
                            'secure',
                        ].join('; ');
                    }

                    window.Check24.cookieBanner.c24consent.giveConsent(
                        window.Check24.cookieBanner.c24consent.getConfiguredConsent(),
                    );
                },
                countCookieConsent: function (value) {
                    var request = new XMLHttpRequest();

                    if (!request) {
                        return;
                    }

                    request.open(
                        'GET',
                        'https://www.' +
                            window.Check24.getDomain() +
                            '/ajax/misc/count-cookie-consent/?c24consent=' +
                            value,
                    );
                    request.send();
                },
            },
            /* {initLegacyCookieBanner: function () {
        var button = document.querySelector(".c24-cookie-button");
        window.Check24.cookieBanner.domain = "." + window.Check24.getDomain();
        window.Check24.removeClass(".c24-cookie", "c24-cookie-hide");
        if (window.Check24.cookieBanner.getCookie() != 1 && button) {
            window.Check24.cookieBanner.showBanner(button);
        }
    },
} */ getCookie: function () {
                var value = '; ' + document.cookie;
                var parts = value.split('; ' + 'c24cb' + '=');
                if (parts.length == 2) {
                    return parts.pop().split(';').shift();
                } else {
                    return '';
                }
            },
            setCookie: function () {
                var date = new Date();
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                document.cookie =
                    'c24cb=1; expires=' +
                    date.toGMTString() +
                    '; path=/; domain=' +
                    window.Check24.cookieBanner.domain +
                    '; SameSite=lax; secure';
            },
            /* {showBanner: function(button) {
        window.Check24.addClass(".c24-cookie", "c24-cookie-animate");
        button.addEventListener("click", function() {
            window.Check24.cookieBanner.setCookie();
            window.Check24.cookieBanner.hideBanner();
        });
    },
} */ /* {hideBanner: function() {
        window.Check24.removeClass(".c24-cookie", "c24-cookie-animate");
    }
} */
        };
        window.Check24 = window.Check24 || {};

        window.Check24.stickyHeader = (function () {
            var header = document.querySelector('#c24-header');
            var stickyHeaderApi = {
                initialized: false,
                activateInitialized: false,
                deactivateInitialized: false,
                isSticky: false,
                skyscraper: false,
                active: false,
                headerPos: null,
                init: function () {
                    if (!stickyHeaderApi.initialized) {
                        stickyHeaderApi.initialized = true;
                        stickyHeaderApi.headerPos = header.getBoundingClientRect();
                        var headerHeight = header.offsetHeight;
                        // check vertical position page is loaded
                        if (window.pageYOffset > headerHeight) {
                            stickyHeaderApi.activate(true, headerHeight);
                        } else {
                            stickyHeaderApi.deactivate();
                        }

                        // check if scrolled and start sticky-funciton
                        window.addEventListener('scroll', function () {
                            if (window.pageYOffset > headerHeight) {
                                stickyHeaderApi.activate(false, headerHeight);
                            } else {
                                stickyHeaderApi.deactivate();
                            }
                        });
                    }
                },
                activate: function (active, headerHeight) {
                    window.Check24.addClass('body', 'c24-sticky');
                    var container = document.querySelector('#c24-page-container-header');
                    container.style.paddingTop = headerHeight + 'px';
                    setTimeout(function () {
                        window.Check24.addClass('#c24-header', 'c24-sticky-animate');
                        window.Check24.hide(['.c24-search .c24-search-content', '.c24-search .c24-search-corner']);
                        window.Check24.show('.c24-search-icon');
                    }, 10);
                },
                deactivate: function () {
                    window.Check24.removeClass('body', 'c24-sticky');
                    var container = document.querySelector('#c24-page-container-header');
                    container.style.paddingTop = '0px';
                    window.Check24.removeClass('#c24-header', 'c24-sticky-animate');
                    if (window.innerWidth > 825) {
                        window.Check24.show(['.c24-search .c24-search-content', '.c24-search .c24-search-corner']);
                        window.Check24.hide('.c24-search-icon');
                    }
                },
            };
            return stickyHeaderApi;
        })();

        window.Check24.headerHover = {
            contact: false,
            notification: false,
            mylists: false,
            customer: false,
            search: false,
            callbacks: {
                contact: function () {},
            },
            init: function (ele) {
                window.Check24.headerHover.contact = window.Check24.exists('.c24-contact');
                window.Check24.headerHover.notification = window.Check24.exists('.c24-notification');
                window.Check24.headerHover.mylists = window.Check24.exists('.c24-mylists');
                window.Check24.headerHover.customer = window.Check24.exists('.c24-customer');
                window.Check24.headerHover.search = window.Check24.exists('.c24-search');
                window.Check24.headerHover.setHoverPos();
                if (
                    window.Check24.headerHover.contact &&
                    typeof ele !== 'undefined' &&
                    ele.classList &&
                    ele.classList.contains('c24-contact') &&
                    typeof window.Check24.headerHover.callbacks.contact === 'function'
                ) {
                    window.Check24.headerHover.callbacks.contact();
                }
            },
            getOffset: function (ele) {
                if (window.Check24.exists('#c24-header-top .c24-header-content') && window.Check24.exists(ele)) {
                    var element = document.querySelector(ele);
                    var headerWidth = document.querySelector('#c24-header-top .c24-header-content').offsetWidth;
                    return {
                        width: element.offsetWidth,
                        left: element.offsetLeft,
                        right: headerWidth - element.offsetLeft - element.offsetWidth,
                    };
                }
            },
            setHoverPos: function () {
                if (window.Check24.exists('#c24-header-top .c24-header-content')) {
                    var headerWidth = document.querySelector('#c24-header-top .c24-header-content').offsetWidth;
                } else {
                    return;
                }
                // position notification layer
                if (window.Check24.headerHover.notification === true) {
                    var offset = window.Check24.headerHover.getOffset('.c24-notification'),
                        layerWidth = document.querySelector('.c24-notification-layer-hover').offsetWidth,
                        layerPos;

                    if (layerWidth / 2 > offset.right) {
                        layerPos = 0;
                    } else {
                        layerPos = offset.right + (offset.width - 13) - layerWidth / 2;
                        if (layerPos < 0) {
                            layerPos = 0;
                        }
                    }

                    if (window.innerWidth < 840) {
                        layerPos = offset.right - (layerWidth - offset.width) / 2;
                        if (layerPos < 0) {
                            layerPos = 0;
                        }
                    }

                    document.querySelector('.c24-notification-layer-hover').style.right = layerPos + 'px';
                }

                // position wishlist layer
                if (window.Check24.headerHover.mylists === true) {
                    var offset = window.Check24.headerHover.getOffset('.c24-mylists'),
                        layerWidth = document.querySelector('.c24-mylists-layer').offsetWidth,
                        layerPos;

                    if (layerWidth / 2 > offset.right + offset.width / 2) {
                        layerPos = 0;
                    } else {
                        layerPos = offset.right + offset.width / 2 - layerWidth / 2;
                        if (layerPos < 0) {
                            layerPos = 0;
                        }
                    }

                    if (window.innerWidth < 840) {
                        layerPos = offset.right - (layerWidth - offset.width) / 2;
                        if (layerPos < 0) {
                            layerPos = 0;
                        }
                    }

                    document.querySelector('.c24-mylists-layer').style.right = layerPos + 'px';
                }

                // position contact layer
                if (window.Check24.headerHover.contact === true) {
                    var contact = document.querySelector('.c24-contact'),
                        contactWidth = contact.offsetWidth,
                        contactHover = document.querySelector('.c24-contact-layer'),
                        contactHoverWidth = contactHover.offsetWidth,
                        contactOffset = (contactHoverWidth - contactWidth) / 2,
                        contactHoverPos = headerWidth - contact.offsetLeft - contactWidth - contactOffset;

                    if (headerWidth - contact.offsetLeft - contactWidth / 2 - contactHoverWidth / 2 <= 0) {
                        contactHoverPos = 0;
                    }

                    contactHover.style.right = contactHoverPos + 'px';
                }

                // position search corner
                if (window.Check24.headerHover.search === true) {
                    if (
                        window.Check24.hasClass('body', 'c24-responsive') &&
                        !window.Check24.hasClass('.c24-header', 'c24-search-slim')
                    ) {
                        if (window.innerWidth <= 880) {
                            window.Check24.hide('.c24-search-content');
                            window.Check24.removeClass('.c24-search-icon', 'open');
                        } else {
                            window.Check24.show('.c24-search-content');
                        }
                    }
                }
            },
        };

        window.addEventListener('wireframe-loaded-custom-event', window.Check24.headerHover.init, false);
        window.addEventListener('wireframe-init', window.Check24.headerHover.init, false);
        window.Check24 = window.Check24 || {};

        window.Check24.meinKonto = {
            logoutCallback: null,
            logoutCallbackError: null,
            init: function () {
                // check if meinkonto is available
                if (window.Check24.exists('.c24-customer')) {
                    // customer hover
                    var customer = document.querySelector('.c24-customer');
                    window.Check24.hover.init(
                        '.c24-customer',
                        '.c24-customer-layer',
                        window.Check24.headerHover.init,
                        '',
                        250,
                    );
                    customer.removeEventListener('mouseenter', window.Check24.meinKonto.hideTrigger, false);
                    customer.addEventListener('mouseenter', window.Check24.meinKonto.hideTrigger, false);
                    customer.removeEventListener('touchend', window.Check24.meinKonto.hideTrigger, false);
                    customer.addEventListener('touchend', window.Check24.meinKonto.hideTrigger, false);
                }
                // customer trigger layer functions
                if (window.Check24.exists('.c24-customer-trigger')) {
                    var customerTrigger = document.querySelector('.c24-customer-trigger');
                    customerTrigger.removeEventListener('mouseleave', window.Check24.meinKonto.hideTrigger, false);
                    customerTrigger.addEventListener('mouseleave', window.Check24.meinKonto.hideTrigger, false);
                    var triggerClose = document.querySelector('.c24-customer-trigger-close');
                    triggerClose.removeEventListener('click', window.Check24.meinKonto.hideTrigger, false);
                    triggerClose.addEventListener('click', window.Check24.meinKonto.hideTrigger, false);
                }
            },
            hideTrigger: function () {
                window.Check24.hide('.c24-customer-trigger');
            },
            logout: function () {
                var request = new XMLHttpRequest();
                request.open('GET', '//' + window.Check24.getHost() + '/ajax/user/logout/', true);
                request.withCredentials = true;
                request.onload = function () {
                    var json = JSON.parse(this.response);
                    if (this.status >= 200 && this.status < 400) {
                        if (typeof window.Check24.meinKonto.logoutCallback === 'function' && json.status === 200) {
                            window.Check24.meinKonto.logoutCallback(json);
                        }
                    } else {
                        if (typeof window.Check24.meinKonto.logoutCallback === 'function') {
                            window.Check24.meinKonto.logoutCallbackError(json);
                        }
                    }
                };
                request.onerror = function () {
                    if (typeof window.Check24.meinKonto.logoutCallback === 'function') {
                        window.Check24.meinKonto.logoutCallbackError();
                    }
                };
                request.send();
            },
            updateCustomerArea: false,
            status: function (updateCustomerArea, callback, callbackError) {
                var request = new XMLHttpRequest();
                request.open('GET', '//' + window.Check24.getHost() + '/ajax/user/status/', true);
                request.withCredentials = true;
                request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        var json = JSON.parse(this.response);
                        if (window.Check24.meinKonto?.updateCustomerArea === true) {
                            var userName = json.data.user.name !== '' ? json.data.user.name : 'Mein Konto';
                            if (window.Check24.exists('.c24-customer:not(.c24-customer-guest) .c24-customer-hover')) {
                                var salutationEles = document.querySelectorAll(
                                    '.c24-customer:not(.c24-customer-guest) .c24-customer-hover',
                                );
                                salutationEles.forEach(function (ele) {
                                    ele.innerHTML = userName;
                                });
                            }
                        }
                        if (typeof callback == 'function') {
                            callback(json);
                        }
                        window.Check24.meinKonto?.statusCallback();
                    } else {
                        if (typeof callbackError == 'function') {
                            callbackError();
                        }
                    }
                };
                request.onerror = function () {
                    if (typeof callbackError == 'function') {
                        callbackError();
                    }
                };
                request.send();
            },
            statusCallback: function () {},
        };

        window.addEventListener(
            'wireframe-loaded-custom-event',
            function () {
                window.Check24.meinKonto.init();
                window.Check24.meinKonto.status();
            },
            false,
        );

        window.addEventListener(
            'wireframe-init',
            function () {
                window.Check24.meinKonto.init();
                window.Check24.meinKonto.status();
            },
            false,
        );
        window.Check24 = window.Check24 || {};

        window.Check24.notification = {
            _notificationLoader: function (content) {
                var loader = document.createElement('div');
                loader.classList.add('loader');
                content.appendChild(loader);
            },
            init: function () {
                if (window.Check24.exists('.c24-notification')) {
                    // fetch user count
                    window.Check24.notification.getNotificationCount();
                    // customer hover
                    window.Check24.hover.init(
                        '.c24-notification',
                        '.c24-notification-layer-hover',
                        function () {
                            // Set Header Layer Corners
                            window.Check24.headerHover.init();
                            // Get new notifications, max. every 30 sec.
                            var timestamp = new Date().getTime() / 1000;
                            if (window.Check24.notification._notificationTimestamp < timestamp - 30) {
                                window.Check24.notification._notificationTimestamp = timestamp;
                                // Show spinner
                                var content = document.querySelector('.c24-notification-layer .content');
                                content.innerHTML = '';
                                window.Check24.hide('.c24-notification-layer .all');
                                window.Check24.notification._notificationLoader(content);

                                var request = new XMLHttpRequest();
                                request.open(
                                    'GET',
                                    '//' + window.Check24.getHost() + '/ajax/user/notification/list/',
                                    true,
                                );
                                request.withCredentials = true;
                                request.onload = function () {
                                    var json = JSON.parse(this.response);
                                    if (this.status >= 200 && this.status < 400) {
                                    } else {
                                        window.Check24.notification._notificationTimestamp = 0;
                                        json = { status: 400 };
                                    }
                                    window.Check24.notification._notificationRender(json);
                                };
                                request.onerror = function () {
                                    window.Check24.notification._notificationTimestamp = 0;
                                    var json = { status: 400 };
                                    window.Check24.notification._notificationRender(json);
                                };
                                request.send();
                            } else {
                                if (window.Check24.notification._notificationCache !== null) {
                                    window.Check24.notification._notificationRender(
                                        window.Check24.notification._notificationCache,
                                    );
                                }
                            }
                        },
                        '',
                        250,
                    );
                    var layer = document.querySelector('.c24-notification-layer-hover');
                    layer.addEventListener(
                        'click',
                        function (e) {
                            e.stopPropagation();
                        },
                        false,
                    );
                }
            },
            _notificationTimestamp: 0,
            _notificationCache: null,
            _notificationUrl: '//kundenbereich.' + window.Check24.getDomain() + '/',
            _notificationQuery: 'o=notifications',
            _notificationParams: false,
            _notificationText: '',
            getNotificationCount: function () {
                var request = new XMLHttpRequest();
                request.open('GET', '//' + window.Check24.getHost() + '/ajax/user/notification/count/', true);
                request.withCredentials = true;
                request.onload = function () {
                    var json = JSON.parse(this.response);
                    if (this.status >= 200 && this.status < 400) {
                        if (json.hasOwnProperty('data')) {
                            window.Check24.notification._notificationCount(json.data.unread_count);
                        }
                    }
                };
                request.send();
            },
            _notificationCount: function (count) {
                var countEl = document.querySelector('.c24-notification-count');
                var str = '';
                if (window.Check24.exists('.c24-notification-count')) {
                    if (count > 0) {
                        str = '(' + count + ') ';
                        countEl.innerHTML = count;
                        window.Check24.show('.c24-notification-count');
                    } else {
                        window.Check24.hide('.c24-notification-count');
                    }
                }
                var title = document.title;
                document.title = title.replace(/^(\(\d*\) |)/, str);
            },
            _notificationRender: function (json) {
                window.Check24.notification._notificationCache = json;
                var content = document.querySelector('.c24-notification-layer .content');
                content.innerHTML = '';
                // If status 200, render list of notifications
                if (json.status === 200) {
                    // Update count bubble and page title
                    window.Check24.notification._notificationCount(json.data.unread_count);

                    // Render List
                    var list = json.data.list;
                    if (list.length > 0) {
                        // Add spaces to text as placeholder '... mehr', for linebreak
                        var ph = new Array(11).join('&nbsp;');
                        list.forEach(function (v, k) {
                            // Set status as class
                            var status = v.read ? 'read' : 'unread';
                            var div = document.createElement('a');
                            div.classList.add('message', status);
                            div.href =
                                '//kundenbereich.' + window.Check24.getDomain() + '/?o=notifications&hash=' + v.hash;
                            div.setAttribute('target', '_blank');

                            // Render Message
                            var sender = document.createElement('div');
                            sender.classList.add('sender');
                            sender.innerHTML = v.sender;
                            var dateEle = document.createElement('div');
                            dateEle.classList.add('date');
                            dateEle.innerHTML = window.Check24.notification._notificationRenderTime(v.date);
                            var title = document.createElement('div');
                            title.classList.add('title');
                            title.innerHTML = v.title;
                            var more = document.createElement('div');
                            more.classList.add('more');
                            var anker = document.createElement('a');
                            anker.innerHTML = 'mehr';
                            more.appendChild(anker);
                            var text = document.createElement('div');
                            text.classList.add('text');
                            text.innerHTML = v.body + ph;
                            text.appendChild(more);

                            div.appendChild(sender);
                            div.appendChild(dateEle);
                            div.appendChild(title);
                            div.appendChild(text);
                            content.appendChild(div);

                            div.addEventListener('touchend', function () {
                                var link =
                                    '//kundenbereich.' +
                                    window.Check24.getDomain() +
                                    '/?o=notifications&hash=' +
                                    v.hash;
                                window.open(link, '_blank');
                            });

                            // If message text is longer than field, show dots before 'mehr'
                            var messages = document.querySelectorAll(
                                    '.c24-notification-layer .content .message:last-child .text',
                                ),
                                first = messages[0],
                                layer = document.querySelector('.c24-notification-layer-hover');
                            if (first.scrollHeight > first.offsetHeight || layer.style.display !== 'block') {
                                document
                                    .querySelector('.c24-notification-layer .content .message:last-child .text .more')
                                    .classList.add('dot');
                            }
                        });
                    } else {
                        // if list is empty, but more messages available show text
                        var empty = document.createElement('div');
                        empty.classList.add('empty');
                        if (json.data.has_more === true) {
                            empty.innerHTML = 'Sie haben aktuell keine ungelesenen Benachrichtigungen.';
                        } else {
                            empty.innerHTML = 'Sie haben aktuell keine Benachrichtigungen.';
                        }
                        content.appendChild(empty);
                    }
                    // Render show all button
                    var linkEle = document.querySelector('.c24-notification-layer .all');
                    var link =
                        window.Check24.notification._notificationUrl +
                        '?' +
                        window.Check24.notification._notificationQuery;
                    if (json.data.has_more === true) {
                        // Is unread count bigger than 1 show count in button
                        var linkText = 'Alle anzeigen';
                        if (json.data.unread_count > 3) {
                            linkText = 'Alle ' + json.data.unread_count + ' anzeigen';
                        }
                        linkEle.href = link;
                        linkEle.innerHTML = linkText;
                        window.Check24.show('.c24-notification-layer .all');
                    }
                    // Check for custom text
                    if (window.Check24.notification._notificationText !== '') {
                        linkEle.href = link;
                        linkEle.innerHTML = window.Check24.notification._notificationText;
                        window.Check24.show('.c24-notification-layer .all');
                    }
                } else {
                    // If login is not active show login and message
                    var empty = document.createElement('div');
                    empty.classList.add('empty');
                    empty.innerHTML =
                        'Bitte melden Sie sich in Ihrem Kundenkonto an, um Ihre Benachrichtigungen zu lesen.';
                    content.appendChild(empty);

                    var initCount = document.querySelector('.c24-notification-count').innerHTML;
                    if (initCount !== '' && Math.floor(initCount) < 1) {
                        window.Check24.hide('.c24-notification-icon-svg-active');
                        window.Check24.show('.c24-notification-icon-svg');
                    }

                    var linkEle = document.querySelector('.c24-notification-layer .all');
                    linkEle.classList.add('c24-meinkonto-login-link');
                    linkEle.href =
                        '//kundenbereich.' +
                        window.Check24.getDomain() +
                        '/' +
                        '?' +
                        window.Check24.notification._notificationQuery;
                    linkEle.innerHTML = 'zur Anmeldung';
                    window.Check24.show('.c24-notification-layer .all');
                }
            },
            _notificationRenderTime: function (dateString) {
                // Parse Mysql date
                var dateArray = dateString.split(/[- :]/);
                var date = new Date(
                    dateArray[0],
                    dateArray[1] - 1,
                    dateArray[2],
                    dateArray[3],
                    dateArray[4],
                    dateArray[5],
                );
                var today = new Date();
                if (
                    date.getYear() === today.getYear() &&
                    date.getMonth() === today.getMonth() &&
                    date.getDate() === today.getDate()
                ) {
                    return [date.getHours(), ('0' + date.getMinutes()).slice(-2)].join(':');
                }
                if (
                    date.getYear() === today.getYear() &&
                    date.getMonth() === today.getMonth() &&
                    date.getDate() === today.getDate() - 1
                ) {
                    return 'gestern';
                }
                today.setDate(today.getDate() - 5);
                if (date > today) {
                    var dayNames = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
                    return dayNames[date.getDay()];
                }
                return [
                    ('0' + date.getDate()).slice(-2),
                    ('0' + (date.getMonth() + 1)).slice(-2),
                    date.getFullYear(),
                ].join('.');
            },
            notificationSetLoginParams: function (url, query) {
                window.Check24.notification._notificationParams = true;
                window.Check24.notification._notificationUrl = url;
                window.Check24.notification._notificationQuery = query;
            },
        };

        window.addEventListener(
            'wireframe-loaded-custom-event',
            function () {
                window.Check24.notification.init();
            },
            false,
        );

        window.addEventListener(
            'wireframe-init',
            function () {
                window.Check24.notification.init();
            },
            false,
        );
        window.Check24 = window.Check24 || {};

        window.Check24.meineListen = {
            mylists: 0,
            updated: false,
            updatedCount: 0,
            _meineListenTimestamp: 0,
            _meineListenCache: null,
            _meineListenQuery: 'o=lists',
            wishlistEle: '.c24-mylists',
            countEle: '.c24-mylists-count',
            icon: '.c24-mylists-icon-svg',
            showItems: null,
            _wishlistLoader: function (content) {
                var loader = document.createElement('div');
                loader.classList.add('loader');
                content.appendChild(loader);
            },
            init: function () {
                window.Check24.meineListen.updated = false;
                window.Check24.meineListen.updatedCount = 0;
                // check if meinelisten is available
                if (window.Check24.exists(window.Check24.meineListen.wishlistEle)) {
                    window.Check24.hover.init(
                        '.c24-mylists',
                        '.c24-mylists-layer',
                        window.Check24.meineListen.getLists,
                        '',
                        250,
                    );
                    window.Check24.meineListen.getCountAjax();
                }
            },
            getCountAjax: function (callback, callbackError) {
                var request = new XMLHttpRequest();
                request.open('POST', '//' + window.Check24.getHost() + '/ajax/user/wishlist/count/', true);
                request.withCredentials = true;
                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                var params = 'count=' + window.Check24.meineListen.mylists;
                request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        var json = JSON.parse(this.response);
                        if (typeof json.data !== 'undefined' && typeof json.data.count !== 'undefined') {
                            window.Check24.meineListen.mylists = json.data.count;
                            if (typeof window.Check24.meineListen._meineListenCount == 'function') {
                                window.Check24.meineListen._meineListenCount(window.Check24.meineListen.mylists);
                            }
                        }
                        if (typeof callback == 'function') {
                            callback(this.response);
                        }
                    } else {
                        if (typeof callbackError == 'function') {
                            callbackError();
                        }
                    }
                };
                request.onerror = function () {
                    if (typeof callbackError == 'function') {
                        callbackError();
                    }
                };
                request.send(params);
            },
            setCountAjax: function (count, callback, callbackError) {
                var request = new XMLHttpRequest();
                request.open('POST', '//' + window.Check24.getHost() + '/ajax/user/wishlist/count/', true);
                request.withCredentials = true;
                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                var params = 'change=' + count;
                request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        var responseData = JSON.parse(this.response);
                        if (responseData.hasOwnProperty('data') && responseData.data.hasOwnProperty('count')) {
                            if (typeof window.Check24.meineListen._meineListenCount == 'function') {
                                window.Check24.meineListen.mylists = responseData.data.count;
                                window.Check24.meineListen._meineListenCount(window.Check24.meineListen.mylists);
                            }
                        }
                        if (typeof callback == 'function') {
                            callback(this.response);
                        }
                    } else {
                        if (typeof callbackError == 'function') {
                            callbackError();
                        }
                    }
                };
                request.onerror = function () {
                    if (typeof callbackError == 'function') {
                        callbackError();
                    }
                };
                request.send(params);
            },
            getLists: function (callback, callbackError) {
                // Get lists, max. every 30 sec.
                var timestamp = new Date().getTime() / 1000;
                if (window.Check24.meineListen._meineListenTimestamp < timestamp - 5) {
                    window.Check24.meineListen._meineListenTimestamp = timestamp;
                    // Show spinner
                    var content = document.querySelector('.c24-mylists-layer');
                    window.Check24.hide([
                        '.c24-mylists-layer .empty',
                        '.c24-mylists-layer .all',
                        '.c24-mylists-layer .c24-mylists-available',
                    ]);
                    window.Check24.meineListen._wishlistLoader(content);
                    window.Check24.meineListen.getListsAjax(callback, callbackError);
                } else {
                    if (window.Check24.meineListen._meineListenCache !== null) {
                        window.Check24.meineListen._meineListenRender(window.Check24.meineListen._meineListenCache);
                    }
                }
            },
            getListsAjax: function (callback, callbackError) {
                var request = new XMLHttpRequest();
                request.open('POST', '//' + window.Check24.getHost() + '/ajax/user/wishlist/get/', true);
                request.withCredentials = true;
                request.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                var params =
                    'items=' +
                    (window.Check24.meineListen.showItems !== null ? window.Check24.meineListen.showItems : '');
                request.onload = function () {
                    var json = JSON.parse(this.response);
                    if (this.status >= 200 && this.status < 400) {
                        if (typeof callback == 'function') {
                            callback(this.response);
                        }
                    } else {
                        window.Check24.meineListen._meineListenTimestamp = 0;
                        json = { status: 403 };
                        if (typeof callbackError == 'function') {
                            callbackError();
                        }
                    }
                    if (typeof window.Check24.meineListen._meineListenRender == 'function') {
                        window.Check24.meineListen._meineListenRender(json);
                    }
                };
                request.onerror = function () {
                    window.Check24.meineListen._meineListenTimestamp = 0;
                    var json = { status: 403 };
                    if (typeof window.Check24.meineListen._meineListenRender == 'function') {
                        window.Check24.meineListen._meineListenRender(json);
                    }
                    if (typeof callbackError == 'function') {
                        callbackError();
                    }
                };
                request.send(params);
            },
            _meineListenCount: function (count) {
                var countEl = document.querySelector(window.Check24.meineListen.countEle);
                if (window.Check24.exists('.c24-mylists-home')) {
                    if (count > 0) {
                        countEl.innerHTML = count;
                        window.Check24.show(window.Check24.meineListen.countEle);
                    } else {
                        window.Check24.hide(window.Check24.meineListen.countEle);
                    }
                }
                if (typeof window.Check24.meineListen.countUpdate == 'function') {
                    window.Check24.meineListen.countUpdate(count);
                }
            },
            _meineListenRender: function (json) {
                window.Check24.meineListen._meineListenCache = json;
                // If status 200, render list of myLists
                if (json.status === 200) {
                    window.Check24.hide(['.c24-mylists-layer .c24-mylists-no-items', '.c24-mylists-layer .empty']);
                    var layer = document.querySelector('.c24-mylists-layer');
                    layer.style.width = '384px';
                    // Update count bubble
                    var wishlist = json.data;
                    window.Check24.meineListen.mylists = json.count;
                    window.Check24.meineListen._meineListenCount(window.Check24.meineListen.mylists);
                    if (wishlist.length > 0) {
                        document.querySelector('.c24-mylists-lists-items').innerHTML = '';
                        // Update lists layer
                        var wrapper = document.querySelector('.c24-mylists-layer-content .c24-mylists-lists-items');
                        wishlist.forEach(function (v, k) {
                            var ele = document.createElement('a'),
                                product = document.createElement('div'),
                                imageWrapper = document.createElement('div'),
                                image = document.createElement('img'),
                                priceWrapper = document.createElement('div'),
                                pricePrefix = document.createElement('span'),
                                priceFormer = document.createElement('span'),
                                price = document.createElement('span'),
                                titleWrapper = document.createElement('div'),
                                title = document.createElement('div'),
                                subtitle = document.createElement('div'),
                                cntWrapper = document.createElement('div'),
                                groupWrapper = document.createElement('div'),
                                groupCount = document.createElement('span'),
                                groupText = document.createElement('span');

                            ele.classList.add('c24-mylists-item', 'c24-mylists-item-' + k);
                            product.classList.add('c24-mylists-item-product');
                            imageWrapper.classList.add('c24-mylists-item-img-wrapper');
                            image.classList.add('c24-mylists-item-img');
                            priceWrapper.classList.add('c24-mylists-item-price-wrapper', 'clearfix');
                            price.classList.add('c24-mylists-item-price');
                            titleWrapper.classList.add('c24-mylists-item-title-wrapper');
                            title.classList.add('c24-mylists-item-title');
                            subtitle.classList.add('c24-mylists-item-subtitle');
                            groupWrapper.classList.add('c24-mylists-item-group');
                            groupCount.classList.add('c24-mylists-item-group-count');
                            cntWrapper.classList.add('c24-mylists-item-wrapper');

                            if (v.button && v.button.desktop && v.button.desktop.url) {
                                ele.href = v.button.desktop.url;
                            }

                            if (v.product && v.product.text) {
                                product.innerHTML = v.product.text;
                            }
                            if (v.image && v.image !== '') {
                                image.src = v.image;
                            }
                            if (v.details && v.details.short && v.details.short.line1) {
                                title.innerHTML = v.details.short.line1;
                            }
                            if (v.details && v.details.short && v.details.short.line2) {
                                subtitle.innerHTML = v.details.short.line2;
                            }
                            if (v.payment && v.payment.amount) {
                                price.innerHTML = v.payment.amount + ' \u20ac';
                            }
                            if (v.payment && v.payment.prefix) {
                                pricePrefix.innerHTML = v.payment.prefix;
                                pricePrefix.classList.add('price-prefix');
                            }
                            if (v.former_payment && v.former_payment.amount && v.former_payment.amount !== '') {
                                priceFormer.innerHTML = v.former_payment.amount + ' \u20ac';
                                priceFormer.classList.add('former-payment');
                            }

                            priceWrapper.appendChild(pricePrefix);
                            if (v.former_payment && v.former_payment.amount && v.former_payment.amount !== '') {
                                priceWrapper.appendChild(priceFormer);
                            }
                            priceWrapper.appendChild(price);

                            titleWrapper.appendChild(product);
                            titleWrapper.appendChild(title);
                            titleWrapper.appendChild(subtitle);

                            if (v.details && v.details.list && v.details.list.count && v.details.list.text) {
                                groupCount.innerHTML = v.details.list.count;
                                groupText.innerHTML = ' ' + v.details.list.text;
                                groupWrapper.appendChild(groupCount);
                                groupWrapper.appendChild(groupText);
                                titleWrapper.appendChild(groupWrapper);
                            }

                            imageWrapper.append(image);

                            cntWrapper.appendChild(imageWrapper);
                            cntWrapper.appendChild(titleWrapper);

                            ele.appendChild(cntWrapper);
                            if (v.payment && v.payment.amount) {
                                ele.appendChild(priceWrapper);
                            }

                            wrapper.appendChild(ele);
                            ele.addEventListener('touchend', function (e) {
                                var link = this.getAttribute('href');
                                window.open(link, '_self');
                                return false;
                            });
                        });

                        var loader = document.querySelector('.c24-mylists-layer .loader');
                        if (loader) {
                            loader.parentNode.removeChild(loader);
                        }
                        window.Check24.show('.c24-mylists-layer .c24-mylists-available');

                        window.Check24.meineListen.renderWishlistLink(json.user);
                    } else {
                        window.Check24.meineListen._meineListenDefaultRender(json.user);
                    }
                } else {
                    window.Check24.meineListen._meineListenDefaultRender();
                }
                // Set Header Corners
                window.Check24.headerHover.init();
            },
            _meineListenDefaultRender: function (user) {
                var loader = document.querySelector('.c24-mylists-layer .loader');
                if (loader) {
                    loader.parentNode.removeChild(loader);
                }
                var layer = document.querySelector('.c24-mylists-layer');
                if (user) {
                    window.Check24.hide('.c24-mylists-layer .empty');
                    window.Check24.show('.c24-mylists-layer .c24-mylists-no-items');
                    layer.style.width = '200px';
                } else {
                    window.Check24.hide('.c24-mylists-layer .c24-mylists-no-items');
                    window.Check24.show('.c24-mylists-layer .empty');
                    layer.style.width = '340px';
                    window.Check24.meineListen.renderWishlistLink(false);
                }
                // Set Header Corners
                window.Check24.headerHover.init();
            },
            renderWishlistLink: function (user) {
                var allLink = document.querySelector('.c24-mylists-layer .all');
                var text = document.querySelector('.c24-mylists-layer .all span');
                if (allLink) {
                    allLink.href =
                        '//kundenbereich.' +
                        window.Check24.getDomain() +
                        '/' +
                        '?' +
                        window.Check24.meineListen._meineListenQuery;
                    text.innerHTML = 'zum Merkzettel';
                    allLink.classList.add('c24-meinkonto-wishlist-link');
                    window.Check24.show('.c24-mylists-layer .all');
                    allLink.addEventListener('touchend', function (e) {
                        var link = this.getAttribute('href');
                        window.open(link, '_self');
                        return false;
                    });
                }
            },
            meineListenSetLoginParams: function (query) {
                window.Check24.meineListen._meineListenQuery = query;
            },
            addItem: function (count, callback, callbackError) {
                if (!isNaN(parseFloat(count)) && isFinite(count)) {
                    window.Check24.meineListen.mylists = window.Check24.meineListen.mylists + count;
                    window.Check24.meineListen.setCountAjax(count, callback, callbackError);
                    window.Check24.meineListen._itemActionCallback(window.Check24.meineListen.mylists);
                    if (typeof window.C24App.increaseWishlistCount == 'function') {
                        window.C24App.increaseWishlistCount(count, callback);
                    }
                }
            },
            removeItem: function (count, callback, callbackError) {
                if (!isNaN(parseFloat(count)) && isFinite(count)) {
                    window.Check24.meineListen.mylists = window.Check24.meineListen.mylists - count;
                    if (window.Check24.meineListen.mylists < 0) {
                        window.Check24.meineListen.mylists = 0;
                    }
                    window.Check24.meineListen.setCountAjax(-count, callback, callbackError);
                    window.Check24.meineListen._itemActionCallback(window.Check24.meineListen.mylists);
                    if (typeof window.C24App.decreaseWishlistCount == 'function') {
                        window.C24App.decreaseWishlistCount(count, callback);
                    }
                }
            },
            _itemActionCallback: function (count) {
                window.Check24.meineListen._meineListenCount(count);
                window.Check24.meineListen._meineListenTimestamp = 0;
                window.Check24.meineListen.updated = true;
            },
            countUpdate: function () {},
        };

        window.addEventListener('wireframe-loaded-custom-event', window.Check24.meineListen.init, false);
        window.addEventListener('wireframe-init', window.Check24.meineListen.init, false);
        window.Check24 = window.Check24 || {};

        window.Check24.contact = {
            isContactLayerEnabled: true,
            init: function () {
                var isLoaderInitialized =
                    typeof window.Check24.loader !== 'undefined' &&
                    window.Check24.loader !== null &&
                    window.Check24.loader.initialized;
                if (
                    window.Check24.exists('.c24-contact') &&
                    window.Check24.contact.isContactLayerEnabled &&
                    !isLoaderInitialized
                ) {
                    window.Check24.hover.init(
                        '.c24-contact',
                        '.c24-contact-layer',
                        window.Check24.headerHover.init,
                        '',
                        250,
                    );
                    var contactEle = document.querySelector('.c24-contact-content');
                    //contactEle.removeEventListener('focus', window.Check24.contact.showLayer, false);
                    //contactEle.addEventListener('focus', window.Check24.contact.showLayer, false);
                    //contactEle.removeEventListener('blur', window.Check24.contact.hideLayer, false);
                    //contactEle.addEventListener('blur', window.Check24.contact.hideLayer, false);
                }
            },
            showLayer: function () {
                window.Check24.show('.c24-contact-layer');
                var contactLayer = document.querySelector('.c24-contact-layer');
                contactLayer.style.visibility = 'visible';
            },
            hideLayer: function () {
                window.Check24.hide('.c24-contact-layer');
                var contactLayer = document.querySelector('.c24-contact-layer');
                contactLayer.style.visibility = 'hidden';
            },
        };
        window.addEventListener(
            'wireframe-loaded-custom-event',
            function () {
                window.Check24.contact.init();
            },
            false,
        );
        window.addEventListener(
            'wireframe-init',
            function () {
                window.Check24.contact.init();
            },
            false,
        );
        window.Check24 = window.Check24 || {};

        window.Check24.hitsSearch = {
            actualSearchString: '',
            userActualSearchString: '',
            ignoreNextFocusEvent: false,
            blurTimeOut: null,
            config: {
                version: '20210607-1',
                env: 'prod',
                params: {
                    delay: 0,
                    endpoint: '//search.check24.de',
                    suggestEndpoint: '//search.' + window.Check24.getDomain() + '/api/suggest/2.1',
                    resultElement: '.hits-suggest-wrapper',
                    fixedWidth: 0, // Set fixed width to overwrite auto-width
                    minWidth: 400, // Will only apply when fixed with is 0
                    setFocus: false, // Whether or not to automatically focus the input element
                    directlinkCount: 2, // Max. number of direct links to show (dropdown)
                    categoryCount: 3, // Max. number of categories to show (dropdown)
                    totalItemsCount: 13, // Max. number of items in total to show (dropdown)
                    suggestTracking: {
                        source: {
                            type: 'hidden',
                            name: 'source',
                            value: 'suggest',
                            id: 'source_suggest',
                        },
                        position: {
                            type: 'hidden',
                            name: 'p',
                            value: 0,
                            id: 'position_suggest',
                        },
                        fragment: {
                            type: 'hidden',
                            name: 'f',
                            value: '',
                            id: 'fragment_suggest',
                        },
                    },
                    items: [],
                    itemsFormatCallback: function (items) {
                        return items;
                    },
                    headerContainerId: 'c24-page-container-header',
                    breadCrumpId: 'c24-breadcrumb',
                    greyOutClass: 'search-grey-out-overlay',
                    useGreyOut: true,
                },
            },
            deviceParams: {
                desktop: {
                    searchElement: '#c24-search-header',
                    searchSubmitButtonSelector: '.c24-search-button',
                    formID: 'c24-search-form',
                    suggestPosition: '#c24-search-header',
                    searchButton: 'c24-search-button',
                    takeOverArrow: !1,
                },
                mobile: {
                    searchElement: '#c24m-sitesearch-suggester',
                    searchSubmitButtonSelector: '.c24m-search-button',
                    formID: 'c24m-search-form',
                    suggestPosition: '#c24-header-bottom',
                    searchButton: 'c24m-search-button',
                    takeOverArrow: !0,
                },
            },
            init: function () {
                var deviceType = this.getDeviceType();
                this.setDeviceParameters(deviceType);
                if (!this.searchElement) {
                    return;
                }
                this.destroyPluginIfBinded();
                this.searchElement.classList.add('hits-search-element');
                this.searchElement.setAttribute('autocomplete', 'off');
                //we have a binded jquery code on submit button in desktop template layer which fires a warning.
                // To be removed asap the layer template gets the new version!!
                document.getElementsByClassName(this.deviceParams[deviceType].searchButton)[0].onclick = function () {};
                this.listeners();
            },
            destroyPluginIfBinded: function () {
                if (window.Check24.hitsSearch.searchElement.classList.contains('hits-search-element')) {
                    window.Check24.hitsSearch.searchElement.classList.remove('hits-search-element');
                }
            },
            getDeviceType: function () {
                if (window.Check24.hitsSearch.isMobileVersion()) {
                    return 'mobile';
                } else {
                    return 'desktop';
                }
            },
            isMobileVersion: function () {
                return document.getElementById('c24m-search-form');
            },
            setDeviceParameters: function (type) {
                this.searchElement = document.querySelector(window.Check24.hitsSearch.deviceParams[type].searchElement);
                this.searchSubmitButtonSelector = document.querySelector(
                    window.Check24.hitsSearch.deviceParams[type].searchSubmitButtonSelector,
                );
                this.config.params.formID = window.Check24.hitsSearch.deviceParams[type].formID;
                this.config.params.suggestPosition = document.querySelector(
                    window.Check24.hitsSearch.deviceParams[type].suggestPosition,
                );
                this.config.params.takeOverArrow = window.Check24.hitsSearch.deviceParams[type].takeOverArrow;
            },
            listeners: function () {
                window.Check24.hitsSearch.inputChangeListener();
                window.Check24.hitsSearch.keyDownListener();
                window.Check24.hitsSearch.keyUpListener();
                window.Check24.hitsSearch.focusListener();
                window.Check24.hitsSearch.focusOutListener();
                window.Check24.hitsSearch.blurListener();
                window.Check24.hitsSearch.submitSearchButtonListener();
                window.Check24.hitsSearch.mobileTriggerPageBlockingLayer();
                window.Check24.hitsSearch.windowFocusListener();
                window.Check24.hitsSearch.windowBlurListener();
                window.Check24.hitsSearch.clickInputListener();
                window.Check24.hitsSearch.leaveListener();
            },
            leaveListener: function () {
                window.onbefore__CONTAINED_unload__ = function () {
                    window.Check24.hitsSearch.removeOverlay();
                };
            },
            windowFocusListener: function () {
                window.addEventListener('focus', () => {
                    window.Check24.hitsSearch.ignoreNextFocusEvent = navigator.userAgent.indexOf('Win') != -1;
                });
            },
            windowBlurListener: function () {
                window.addEventListener('blur', () => {
                    if (window.Check24.hitsSearch.blurTimeOut) {
                        clearTimeout(window.Check24.hitsSearch.blurTimeOut);
                        window.Check24.hitsSearch.blurTimeOut = null;
                    }
                });
            },
            keyDownListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('keydown', function (event) {
                    window.Check24.hitsSearch._executeSuggestInteraction(event);
                });
            },
            keyUpListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('keyup', function (event) {
                    var key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
                    // Check input value for mobile closing icon
                    if (window.Check24.hitsSearch.getDeviceType() === 'mobile') {
                        if (event.target.value !== '') {
                            window.Check24.addClass('#c24m-sitesearch-suggester', 'active');
                            window.Check24.show('.c24m-search-clear');
                        } else {
                            window.Check24.removeClass('#c24m-sitesearch-suggester', 'active');
                            window.Check24.hide('.c24m-search-clear');
                        }
                    }
                    // Submit on enter
                    if (key === 13) {
                        var query = window.Check24.hitsSearch.searchElement.value;
                        if (query.trim() !== '') {
                            document.querySelector('#' + window.Check24.hitsSearch.config.params.formID).submit();
                        } else {
                            return false;
                        }
                    }
                    // Escape button close AS
                    if (key === 27) {
                        window.Check24.hitsSearch.removeOverlay();
                    }
                    if ([37, 38, 39].indexOf(key) >= 0) {
                        // Arrows (except arrow down)
                        return;
                    }
                    // Arrow down special handling
                    if (document.querySelector('.hits-suggest') && key === 40) {
                        return;
                    }
                    window.Check24.hitsSearch.actualSearchString = window.Check24.hitsSearch.searchElement.value;
                });
            },
            inputChangeListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('input', function (event) {
                    window.Check24.hitsSearch.actualSearchString = event.target.value;
                    if (window.Check24.hitsSearch.config.params.delay) {
                        clearTimeout(window.Check24.hitsSearch.config.params.delay);
                    }
                    window.Check24.hitsSearch.config.params.delay = setTimeout(function () {
                        window.Check24.hitsSearch._triggerSuggest(window.Check24.hitsSearch.config.params.delay);
                    }, 50);
                });
            },
            focusListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('focus', function () {
                    if (window.Check24.hitsSearch.ignoreNextFocusEvent) {
                        window.Check24.hitsSearch.ignoreNextFocusEvent = false;
                        return;
                    }
                    window.Check24.hitsSearch._addGreyOutOverlay();
                    window.Check24.hitsSearch._triggerSuggest((window.Check24.hitsSearch.config.params.delay = 0));
                });
            },
            blurListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('blur', function () {
                    window.Check24.hitsSearch.blurTimeOut = setTimeout(window.Check24.hitsSearch.removeOverlay, 50);
                    return true;
                });
            },
            focusOutListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('focusout', function () {
                    window.Check24.hitsSearch.removeOverlay();
                });
            },
            submitSearchButtonListener: function () {
                window.Check24.hitsSearch.searchSubmitButtonSelector.addEventListener('click', function () {
                    var query = window.Check24.hitsSearch.searchElement.value;
                    if (query.trim() !== '') {
                        document.querySelector('#' + window.Check24.hitsSearch.config.params.formID).submit();
                    } else {
                        window.Check24.hitsSearch.searchElement.focus();
                    }
                });
            },
            clickInputListener: function () {
                window.Check24.hitsSearch.searchElement.addEventListener('click', function () {
                    window.Check24.hitsSearch._renderItems();
                    window.Check24.hitsSearch._addGreyOutOverlay();
                    return true;
                });
            },
            windowResizeListener: function () {
                window.Check24.hitsSearch.removeOverlay(true);
            },
            mobileTriggerPageBlockingLayer: function () {
                if (window.Check24.hitsSearch.isMobileVersion()) {
                    document.querySelector('#c24m-sitesearch-suggester').addEventListener('click', function (event) {
                        document.getElementById('c24m-page-blocking-layer').style.display = 'block';
                        document.getElementById('c24m-header').style.zIndex = '112';
                    });
                    document.querySelector('#c24m-page-blocking-layer').addEventListener('click', function (event) {
                        document.getElementById('c24m-page-blocking-layer').style.display = 'none';
                        document.getElementById('c24m-search').classList.remove('active');
                        document.getElementById('c24m-header').style.zIndex = 'initial';
                    });
                }
            },
            _triggerSuggest: function (delayNumber) {
                var query = window.Check24.hitsSearch.actualSearchString
                    .replace(/\s+/g, ' ')
                    .toLowerCase()
                    .replace(/^\s+/, '');
                if ('' === query) {
                    window.Check24.hitsSearch.removeSuggestContainter();
                    return;
                }
                if (window.Check24.hitsSearch.config.params.delay !== delayNumber) return;
                window.Check24.hitsSearch.fetchSearchResults(query, delayNumber);
            },
            fetchSearchResults: function (query, delayNumber) {
                window.Check24.hitsSearch.config.params.items = [];
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState !== 4) return;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        var data = JSON.parse(xhr.responseText);
                        if (window.Check24.hitsSearch.config.params.delay !== delayNumber) {
                            return;
                        }
                        window.Check24.hitsSearch.setSuggestsDirectLinks(data.directlinks, query);
                        window.Check24.hitsSearch.setSuggestsPhrases(data.phrases, query);
                        window.Check24.hitsSearch._renderItems();
                    }
                };
                xhr.open(
                    'GET',
                    window.Check24.hitsSearch.config.params.suggestEndpoint + '?query=' + encodeURIComponent(query),
                );
                xhr.send();
            },
            setSuggestsDirectLinks: function (directLinks, query) {
                var query_fragment = '&f=' + query;
                var settings = window.Check24.hitsSearch.config.params;
                for (var x = 0; x < directLinks.length && x < settings.directlinkCount; x++) {
                    var directlinkItem = directLinks[x];
                    var directlinkLabel = window.Check24.hitsSearch.highlightNotIncluded(query, directlinkItem.title);
                    window.Check24.hitsSearch.pushItems(
                        'directlink',
                        directlinkLabel,
                        directlinkItem.title,
                        null,
                        directlinkItem.url + query_fragment,
                    );
                }
            },
            setSuggestsPhrases: function (phrases, query) {
                var settings = window.Check24.hitsSearch.config.params;
                if (settings.items.length && phrases.length) {
                    window.Check24.hitsSearch.pushSeparator();
                }
                for (var i = 0; i < phrases.length; i++) {
                    window.Check24.hitsSearch.setSuggestPhraseItem(phrases[i], query);
                }
                settings.items = settings.itemsFormatCallback(settings.items.slice(0, settings.totalItemsCount));
            },
            setSuggestPhraseItem: function (phraseItem, query) {
                var phraseLabel = window.Check24.hitsSearch.highlightNotIncluded(query, phraseItem.phrase);
                var categories = phraseItem.categories;
                if (categories.length > 0) {
                    categories.unshift('Alle Kategorien');
                    for (var j = 0; j < categories.length && j < settings.categoryCount; ++j) {
                        var category = categories[j];
                        window.Check24.hitsSearch.pushItems(
                            'phrase',
                            phraseLabel,
                            phraseItem.phrase,
                            category.name,
                            null,
                            category.url + '&f=' + query || null,
                        );
                    }
                } else {
                    window.Check24.hitsSearch.pushItems(
                        'phrase',
                        phraseLabel,
                        phraseItem.phrase,
                        null,
                        null,
                        phraseItem.url + '&f=' + query,
                    );
                }
            },
            pushSeparator: function () {
                window.Check24.hitsSearch.config.params.items.push({
                    type: 'separator',
                });
            },
            pushItems: function (type, label, value, category, subtitle, url) {
                if (subtitle == null) {
                    window.Check24.hitsSearch.config.params.items.push({
                        type: type,
                        label: label,
                        value: value,
                        category: category,
                        url: url,
                    });
                } else {
                    window.Check24.hitsSearch.config.params.items.push({
                        type: type,
                        label: label,
                        value: value,
                        subtitle: subtitle,
                        url: url,
                    });
                }
            },
            _escapeRegExp: function (text) {
                return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
            },
            highlightNotIncluded: function (query, result) {
                const regexStringsFromQuery = query
                    .split(/\s/)
                    .map((s) => window.Check24.hitsSearch._escapeRegExp(s))
                    .join('|^');
                var re = new RegExp('(^' + regexStringsFromQuery + ').*$', 'i');
                var results = result.split(/\s/);
                for (var k = 0; k < results.length; k++) {
                    var match = results[k].match(re);
                    if (match) {
                        if (match[0].length > match[1].length) {
                            results[k] = match[1] + '<strong>' + match[0].substr(match[1].length) + '</strong>';
                        }
                    } else {
                        results[k] = '<strong>' + results[k] + '</strong>';
                    }
                }
                return results.join(' ');
            },
            useGreyOut: function (active) {
                window.Check24.hitsSearch.config.params.useGreyOut = active;
            },
            getFirstElementIfItExists: function (collection) {
                if (collection.size > 0) {
                    return collection[0];
                }
                return null;
            },
            _addGreyOutOverlay: function (nodeId = window.Check24.hitsSearch.config.params.headerContainerId) {
                var settings = window.Check24.hitsSearch.config.params;
                if (!settings.useGreyOut || document.getElementsByClassName(settings.greyOutClass).length > 0) {
                    return;
                }
                window.Check24.removeClass('.c24-nav-ele', 'open');
                window.Check24.removeClass('.c24-nav-ele-title', 'open');
                var header = document.getElementById(nodeId);
                var searchIcon = document.querySelector('.c24-search-icon');
                var searchBarHidden = searchIcon && window.getComputedStyle(searchIcon).display !== 'none';
                var breadCrump = document.getElementById(settings.breadCrumpId);
                if (header) {
                    var pageRoot = header.parentElement;
                    if (pageRoot) {
                        var headerHeight = 0;
                        if (searchBarHidden) {
                            var responsiveSearchBar = window.Check24.hitsSearch.getFirstElementIfItExists(
                                header.getElementsByClassName('c24-search'),
                            );
                            var searchBarHeight = responsiveSearchBar ? responsiveSearchBar.clientHeight : 0;
                            var visibleHeader = window.Check24.hitsSearch.getFirstElementIfItExists(
                                header.getElementsByClassName('c24-header-content'),
                            );
                            var visibleHeaderHeight = visibleHeader ? visibleHeader.clientHeight : 0;
                            var breadCrumpHeight = breadCrump ? breadCrump.clientHeight : 0;
                            headerHeight = Math.max(breadCrumpHeight, searchBarHeight) + visibleHeaderHeight;
                            header.style.zIndex = 1001;
                        } else {
                            headerHeight = header.clientHeight;
                        }
                        var contentOverlay = document.createElement('div');
                        contentOverlay.classList.add(settings.greyOutClass);
                        contentOverlay.style.top = `${headerHeight}px`;
                        contentOverlay.style.visibility = 'visible';
                        pageRoot.appendChild(contentOverlay);
                        contentOverlay.addEventListener(
                            'click',
                            function () {
                                window.Check24.hitsSearch.removeOverlay();
                            },
                            false,
                        );
                    }
                    if (breadCrump) {
                        breadCrump.style.zIndex = 0;
                        var breadCrumpOverlay = document.createElement('div');
                        breadCrumpOverlay.classList.add(settings.greyOutClass);
                        breadCrumpOverlay.style.top = '0';
                        breadCrumpOverlay.style.visibility = 'visible';
                        breadCrump.appendChild(breadCrumpOverlay);
                    }

                    if ('visualViewport' in window) {
                        return;
                    }

                    window.addEventListener('resize', window.Check24.hitsSearch.windowResizeListener, { once: true });
                }
            },
            removeOverlay: function (blur = false) {
                if (!this.searchElement) {
                    return;
                }
                window.Check24.hitsSearch.removeSuggestContainter();
                window.Check24.hitsSearch.blurTimeOut = null;
                var settings = window.Check24.hitsSearch.config.params;
                var overlays = document.getElementsByClassName(settings.greyOutClass);
                while (overlays.length > 0) {
                    var overlay = overlays[0];
                    overlay.parentNode.removeChild(overlay);
                }
                if (blur) {
                    window.Check24.hitsSearch.searchElement.blur();
                }

                if ('visualViewport' in window) {
                    return;
                }

                window.removeEventListener('resize', window.Check24.hitsSearch.windowResizeListener);
            },
            _renderItems: function () {
                var settings = window.Check24.hitsSearch.config.params;
                var resultElement = document.querySelector(settings.resultElement)
                    ? document.querySelector(settings.resultElement)
                    : document.createElement('div');
                resultElement.classList.add(settings.resultElement.replace('.', ''));
                resultElement.innerHTML = '';
                if (settings.items.length === 0) {
                    document.getElementById(window.Check24.hitsSearch.config.params.formID).classList.remove('open');
                    return;
                }
                window.Check24.hitsSearch.insertAfter(resultElement, settings.suggestPosition);
                var ul = document.createElement('ul');
                settings.items.forEach(function (item, index) {
                    var li = document.createElement('li');
                    var div = document.createElement('div');
                    if (item.type === 'directlink') {
                        div.innerHTML +=
                            '<a data-url="' +
                            item.url +
                            '" class="hits-suggest-directlink hits-suggest-phraselink">' +
                            item.label +
                            (item.subtitle !== ''
                                ? ' &ndash; <span class="hits-suggest-directlink-subtitle">' + item.subtitle + '</span>'
                                : '') +
                            '</a>';
                    } else if (item.type === 'phrase') {
                        if (item.category != null) {
                            div.innerHTML +=
                                '<a data-url="' +
                                item.url +
                                '" class="hits-suggest-phraselink">' +
                                item.label +
                                '<br><span class="hits-suggest-category">in ' +
                                item.category +
                                '</span></a>';
                            li.classList.add('hits-suggest-cat');
                        } else {
                            div.innerHTML +=
                                '<a data-url="' + item.url + '" class="hits-suggest-phraselink">' + item.label + '</a>';
                        }
                    }
                    if (item.type === 'separator') {
                        div.innerHTML += '<hr />';
                    } else {
                        if (settings.takeOverArrow) {
                            div.innerHTML += '<a class="hits-takeover-arrow" alt="' + item.label + '"></a>';
                        }
                        li.classList.add('hits-suggest-item');
                    }
                    li.appendChild(div);
                    ul.appendChild(li);
                });
                document.getElementById(window.Check24.hitsSearch.config.params.formID).classList.add('open');
                var container = document.createElement('div');
                container.classList.add('hits-suggest');
                container.appendChild(ul);
                resultElement.appendChild(container);
                window.Check24.hitsSearch._refreshListeners();
                window.Check24.hitsSearch._addGreyOutOverlay();
            },
            removeSuggestContainter: function () {
                var hits_suggest = document.getElementsByClassName('hits-suggest');
                while (hits_suggest.length > 0) {
                    hits_suggest[0].parentNode.removeChild(hits_suggest[0]);
                }
                var hits_layer = document.getElementsByClassName('hits-layer');
                while (hits_layer.length > 0) {
                    hits_layer[0].parentNode.removeChild(hits_layer[0]);
                }
                document.getElementById(window.Check24.hitsSearch.config.params.formID).classList.remove('open');
            },
            _toConsumableArray: function (arr) {
                if (Array.isArray(arr)) {
                    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                        arr2[i] = arr[i];
                    }
                    return arr2;
                } else {
                    return Array.from(arr);
                }
            },
            _executeSuggestInteraction: function (event) {
                var settings = window.Check24.hitsSearch.config.params;
                var key = event.charCode ? event.charCode : event.keyCode ? event.keyCode : 0;
                var activeItem = document.querySelector('.hits-suggest-item-active');
                switch (key) {
                    case 38: // arrow up
                        if (activeItem !== null) {
                            activeItem.classList.remove('hits-suggest-item-active');
                            if (
                                []
                                    .concat(
                                        window.Check24.hitsSearch._toConsumableArray(
                                            activeItem.parentElement.childNodes,
                                        ),
                                    )
                                    .indexOf(activeItem) != 0
                            ) {
                                activeItem.previousElementSibling.classList.add('hits-suggest-item-active');
                                window.Check24.hitsSearch._setSearchActualValue(
                                    []
                                        .concat(
                                            window.Check24.hitsSearch._toConsumableArray(
                                                activeItem.parentElement.childNodes,
                                            ),
                                        )
                                        .indexOf(activeItem) - 1,
                                );
                            } else {
                                window.Check24.hitsSearch.setSearchSourceValue(0);
                            }
                        } else {
                            var lastEle = document.querySelector('.hits-suggest-item:last-child');
                            if (lastEle !== null) {
                                lastEle.classList.add('hits-suggest-item-active');
                            }
                            if (typeof settings !== 'undefined') {
                                window.Check24.hitsSearch._setSearchActualValue(settings.items.length - 1);
                            }
                        }
                        event.preventDefault();
                        break;
                    case 40: // arrow down
                        if (activeItem === null) {
                            var suggestItem = document.querySelector('.hits-suggest-item');
                            if (suggestItem !== null) {
                                suggestItem.classList.add('hits-suggest-item-active');
                            }
                            window.Check24.hitsSearch._setSearchActualValue(0);
                        } else {
                            activeItem.classList.remove('hits-suggest-item-active');
                            if (
                                typeof settings !== 'undefined' &&
                                []
                                    .concat(
                                        window.Check24.hitsSearch._toConsumableArray(
                                            activeItem.parentElement.childNodes,
                                        ),
                                    )
                                    .indexOf(activeItem) !=
                                    settings.items.length - 1
                            ) {
                                activeItem.nextElementSibling.classList.add('hits-suggest-item-active');
                                window.Check24.hitsSearch._setSearchActualValue(
                                    []
                                        .concat(
                                            window.Check24.hitsSearch._toConsumableArray(
                                                activeItem.parentElement.childNodes,
                                            ),
                                        )
                                        .indexOf(activeItem) + 1,
                                );
                            } else {
                                window.Check24.hitsSearch.setSearchSourceValue(0);
                            }
                        }
                        event.preventDefault();
                        break;
                    case 13: // enter
                        event.preventDefault();
                        return;
                    default:
                        return; // exit this handler for other keys
                }
            },
            insertAfter: function (el, referenceNode) {
                referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
            },
            /**
             * Initialises/refreshes listeners
             */
            _refreshListeners: function () {
                var hitsSuggestsItem = document.getElementsByClassName('hits-suggest-item');
                var hitsSuggestsTakeOverItem = document.getElementsByClassName('hits-takeover-arrow');
                for (var i = 0; i < hitsSuggestsItem.length; i++) {
                    var current = hitsSuggestsItem[i];
                    current.addEventListener(
                        'mouseenter',
                        window.Check24.hitsSearch.mouseEnterHandler.bind(this, current),
                    );
                    current.addEventListener(
                        'mouseleave',
                        window.Check24.hitsSearch.mouseLeaveHandler.bind(this, current),
                    );
                    //
                    if (window.Check24.hitsSearch.isMobileVersion()) {
                        hitsSuggestsTakeOverItem[i].addEventListener(
                            'click',
                            this.takeOverArrowHandler.bind(this, window.Check24.hitsSearch.config.params.items[i]),
                        );
                    }
                    current.addEventListener(
                        'mousedown',
                        window.Check24.hitsSearch.clickHandler.bind(
                            this,
                            window.Check24.hitsSearch.config.params.items[i],
                        ),
                    );
                }
            },
            takeOverArrowHandler: function (item) {
                window.Check24.hitsSearch.searchElement.value = item.value;
                window.Check24.hitsSearch._triggerSuggest(0);
                window.Check24.hitsSearch.removeSuggestContainter();
            },
            clickHandler: function (item) {
                if (window.Check24.hitsSearch.blurTimeOut) {
                    clearTimeout(window.Check24.hitsSearch.blurTimeOut);
                    window.Check24.hitsSearch.blurTimeOut = null;
                }
                if (typeof item !== 'undefined') {
                    if (item.type === 'directlink' || (typeof item.url != 'undefined' && item.url != null)) {
                        location.href = item.url;
                    } else {
                        window.Check24.hitsSearch.config.params.triggerSearch(item.value, item);
                    }
                }
                return true;
            },
            mouseLeaveHandler: function (current) {
                current.classList.remove('hits-suggest-item-hover');
            },
            mouseEnterHandler: function (current) {
                current.classList.add('hits-suggest-item-hover');
            },
            _setSearchActualValue: function (index) {
                var settings = window.Check24.hitsSearch.config.params;
                if (typeof settings !== 'undefined') {
                    var item = settings.items[index];
                    if (typeof item !== 'undefined') {
                        window.Check24.hitsSearch.searchElement.value = item.value;
                    } else {
                        window.Check24.hitsSearch.value = window.Check24.hitsSearch.actualSearchString;
                    }
                    window.Check24.hitsSearch.setSearchSourceValue(index + 1);
                }
            },
            _suggestTrackingElements: function () {
                return Object.keys(window.Check24.hitsSearch.config.params.suggestTracking);
            },
            setSearchSourceValue: function (index) {
                window.Check24.hitsSearch._suggestTrackingElements().forEach(function callbackFn(element) {
                    var trackingElement = document.querySelector(
                        '#' + window.Check24.hitsSearch.config.params.suggestTracking[element].id,
                    );
                    if (trackingElement !== null && index == 0) {
                        window.Check24.hitsSearch.clearSearchSourceValue(trackingElement);
                    } else {
                        if (trackingElement === null) {
                            window.Check24.hitsSearch.createNewTrackingSuggestInputs(element, index);
                        } else {
                            window.Check24.hitsSearch.setTrackingSuggestInputValue(trackingElement, index);
                        }
                    }
                });
            },
            clearSearchSourceValue: function (trackingElement) {
                if (trackingElement.id !== 'source_suggest') {
                    trackingElement.parentNode.removeChild(trackingElement);
                } else {
                    trackingElement.value = 'input';
                }
                window.Check24.hitsSearch.searchElement.value = window.Check24.hitsSearch.actualSearchString;
            },
            createNewTrackingSuggestInputs: function (trackingElement, index) {
                var sourceInput = document.createElement('input');
                var trackingType = window.Check24.hitsSearch.config.params.suggestTracking[trackingElement];
                sourceInput.type = trackingType.type;
                sourceInput.name = trackingType.name;
                sourceInput.id = trackingType.id;
                window.Check24.hitsSearch.setTrackingSuggestInputValue(sourceInput, index);
                document.querySelector('#' + window.Check24.hitsSearch.config.params.formID).appendChild(sourceInput);
            },
            setTrackingSuggestInputValue: function (trackingElement, index) {
                switch (trackingElement.id) {
                    case 'source_suggest':
                        trackingElement.value = window.Check24.hitsSearch.config.params.suggestTracking.source.value;
                        break;
                    case 'fragment_suggest':
                        trackingElement.value = window.Check24.hitsSearch.actualSearchString;
                        break;
                    default:
                        trackingElement.value = index;
                        break;
                }
            },
        };
        window.Check24.search = {
            iconListener: function () {
                if (window.Check24.exists('.c24-search-icon')) {
                    var searchIcon = document.querySelector('.c24-search-icon');
                    searchIcon.removeEventListener('click', window.Check24.search.handleIconClick, false);
                    searchIcon.addEventListener('click', window.Check24.search.handleIconClick, false);
                }
            },
            handleIconClick: function () {
                if (window.Check24.hasClass('.c24-search-icon', 'open')) {
                    window.Check24.removeClass('.c24-search-icon', 'open');
                    window.Check24.hide(['.c24-search', '.c24-search-corner', '.c24-search-content']);
                    window.Check24.hitsSearch.removeOverlay();
                } else {
                    window.Check24.addClass('.c24-search-icon', 'open');
                    window.Check24.show(['.c24-search', '.c24-search-corner', '.c24-search-content']);
                    var search = document.querySelector('#c24-search-header');
                    if (window.Check24.exists('#c24-search-header')) {
                        search.value = '';
                        search.focus();
                    }
                }
            },
            restoreSlimSearch: function () {
                window.Check24.removeClass('.c24-search-icon', 'open');
                window.Check24.hide(['.c24-search', '.c24-search-corner', '.c24-search-content']);
                window.Check24.hitsSearch.removeOverlay();
            },
        };
        window.addEventListener(
            'wireframe-loaded-custom-event',
            function () {
                window.Check24.hitsSearch.init();
                window.Check24.search.iconListener();
            },
            false,
        );
        window.addEventListener(
            'wireframe-init',
            function () {
                window.Check24.hitsSearch.init();
                window.Check24.search.iconListener();
            },
            false,
        );
        ('use strict');

        (function () {
            if (typeof window.CustomEvent === 'function') {
                return false;
            }
            function CustomEvent(event, params) {
                params = params || {
                    bubbles: false,
                    cancelable: false,
                    detail: null,
                };
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
            }
            window.CustomEvent = CustomEvent;
        })();

        window.Check24 = window.Check24 || {};

        window.Check24.uliloginlayer = {
            config: {
                version: '20250312-1',
                env: 'prod',
                params: {
                    api_product: '',
                    deviceoutput: 'desktop',
                    login_email: '',
                    login_phone: '',
                    login_type: '',
                    login_mode: '',
                    password_reset_type: 'tan',
                    password_reset_ref: '',
                    social_login_callback_url: '',
                    social_login_closing_url:
                        'https://' +
                        (typeof CHECK24_HOST !== 'undefined' ? CHECK24_HOST : window.Check24.getHost()) +
                        '/assets/html/sso/v3/closingULIIframe.html',
                    social_login_base_url: 'https://kundenbereich.check24.de/',
                    points: 'false',
                    custom_param: '',
                    transaction_type: 'none',
                    browserback: '',
                    anonymous: 'false',
                    responsive: 'false',
                    main_width: '',
                    help_width: '',
                    border: 'none',
                    background: '',
                    context: 'loginlayer',
                    mode: '',
                    register_type: 'secure',
                    transfer_token: '',
                    sso_env: '',
                },
                opener: '',
            },
            initialized: false,
            init: function (llconfig) {
                window.Check24.uliloginlayer.setConfig(llconfig);
                window.Check24.uliloginlayer.setLayer();
                window.Check24.uliloginlayer.listener();
                window.Check24.uliloginlayer.initialized = true;
            },
            setConfig: function (llconfig) {
                if (typeof llconfig === 'object' && llconfig !== null) {
                    for (var param in llconfig) {
                        if (llconfig.hasOwnProperty(param)) {
                            if (window.Check24.uliloginlayer.config.params.hasOwnProperty(param)) {
                                window.Check24.uliloginlayer.config.params[param] = llconfig[param];
                            }
                        }
                    }
                }
            },
            setLayer: function () {
                var layer = document.createElement('div');
                var iframe = document.createElement('iframe');
                var close = document.createElement('span');
                layer.setAttribute('class', 'c24-uli-loginlayer');
                iframe.setAttribute('class', 'c24-uli-loginlayer-iframe');
                iframe.classList.add('c24-nolazyload');
                iframe.setAttribute('scrolling', 'no');
                close.setAttribute('class', 'c24-uli-loginlayer-close');
                if (window.Check24.uliloginlayer.config.params.deviceoutput === 'mobile') {
                    var header = document.createElement('div');
                    header.setAttribute('class', 'c24-uli-loginlayer-header');
                    var logo = document.createElement('a');
                    logo.setAttribute('class', 'c24-uli-loginlayer-header-logo');
                    logo.setAttribute('href', 'https://m.check24.de');
                    header.appendChild(logo);
                    layer.appendChild(header);
                }
                layer.appendChild(iframe);
                layer.appendChild(close);
                if (window.Check24.uliloginlayer.config.params.deviceoutput === 'mobile') {
                    document.querySelector('#c24m-page').appendChild(layer);
                } else {
                    document.querySelector('body').appendChild(layer);
                }
            },
            getIframeUrl: function () {
                var url =
                    window.Check24.uliloginlayer.getIframeBaseUrl() +
                    '/' +
                    window.Check24.uliloginlayer.config.version +
                    '/iframe/' +
                    window.Check24.uliloginlayer.config.params.deviceoutput +
                    '/login/';
                var query = '?';
                for (var param in window.Check24.uliloginlayer.config.params) {
                    query = query + param + '=' + window.Check24.uliloginlayer.config.params[param] + '&';
                }
                query = query.substring(0, query.length - 1);
                url = url + query;
                return url;
            },
            getIframeBaseUrl: function () {
                return (
                    'https://anmelden.check24' +
                    (window.Check24.uliloginlayer.config.env === 'prod'
                        ? ''
                        : '-' + window.Check24.uliloginlayer.config.env) +
                    '.de'
                );
            },
            listenerInit: false,
            listener: function () {
                if (!window.Check24.uliloginlayer.listenerInit) {
                    window.Check24.uliloginlayer.listenerInit = true;
                    window.addEventListener('message', window.Check24.uliloginlayer.handleUlDocMsg, false);
                    window.addEventListener(
                        'unified-login-push',
                        window.Check24.uliloginlayer.browserBackRequest,
                        false,
                    );
                    window.addEventListener('unified-login-opener', window.Check24.uliloginlayer.openerEvent, false);
                    if (window.Check24.uliloginlayer.config.params.deviceoutput === 'desktop') {
                        document
                            .querySelector('.c24-blocking-layer')
                            .addEventListener('click', window.Check24.uliloginlayer.closeDefault, false);
                        document
                            .querySelector('.c24-uli-loginlayer-close')
                            .addEventListener('click', window.Check24.uliloginlayer.closeDefault, false);
                    } else if (window.Check24.uliloginlayer.config.params.deviceoutput === 'mobile') {
                        document.querySelector('.c24-uli-loginlayer-close').addEventListener(
                            'click',
                            function () {
                                var iframe = document.querySelector('.c24-uli-loginlayer-iframe').contentWindow;
                                iframe.postMessage('layerClosed', window.Check24.uliloginlayer.getIframeBaseUrl());
                                history.back();
                            },
                            false,
                        );
                    }
                    var openerEles = document.querySelectorAll('.c24-uliloginlayer-login-opener');
                    for (var i = 0; i < openerEles.length; i++) {
                        openerEles[i].removeEventListener('click', window.Check24.uliloginlayer.open, false);
                        openerEles[i].addEventListener('click', window.Check24.uliloginlayer.open, false);
                    }
                    var openerPwrEles = document.querySelectorAll('.c24-uliloginlayer-pwreset-opener');
                    for (var i = 0; i < openerPwrEles.length; i++) {
                        openerPwrEles[i].removeEventListener('click', window.Check24.uliloginlayer.openPwr, false);
                        openerPwrEles[i].addEventListener('click', window.Check24.uliloginlayer.openPwr, false);
                    }
                    var openerRegisterEles = document.querySelectorAll('.c24-uliloginlayer-register-opener');
                    for (var i = 0; i < openerRegisterEles.length; i++) {
                        openerRegisterEles[i].removeEventListener(
                            'click',
                            window.Check24.uliloginlayer.openRegister,
                            false,
                        );
                        openerRegisterEles[i].addEventListener(
                            'click',
                            window.Check24.uliloginlayer.openRegister,
                            false,
                        );
                    }
                    window.removeEventListener('popstate', window.Check24.uliloginlayer.onPopState);
                    window.addEventListener('popstate', window.Check24.uliloginlayer.onPopState);
                }
            },
            isOpen: false,
            beforeOpen: function () {},
            useAppOpener: false,
            appOpenerConfig: {
                username: null,
                loginType: 'login',
                allowRelogin: false,
                loginText: null,
            },
            openInApp: function () {
                window.C24App.triggerUnifiedLogin(
                    window.Check24.uliloginlayer.appOpenerConfig.username,
                    window.Check24.uliloginlayer.appOpenerConfig.loginType,
                    window.Check24.uliloginlayer.appOpenerConfig.allowRelogin,
                    window.Check24.uliloginlayer.appOpenerConfig.loginText,
                );
                window.Check24.uliloginlayer.dispatchCustomEvent('uli-login-layer-open', '');
            },
            open: function (e) {
                if (
                    window.Check24.uliloginlayer.useAppOpener &&
                    window.Check24.uliloginlayer.config.params.deviceoutput === 'tabletapp'
                ) {
                    window.Check24.uliloginlayer.openInApp();
                    return;
                }
                window.Check24.uliloginlayer.isOpen = true;
                window.Check24.uliloginlayer.beforeOpen();
                if (e) {
                    e.target.nodeName === 'A' ? e.preventDefault() : {};
                }
                window.Check24.uliloginlayer.historyCount = 0;
                window.Check24.uliloginlayer.config.params.mode = '';
                window.Check24.uliloginlayer.setAttributeData(e);
                window.Check24.uliloginlayer.addLayer();
                window.Check24.uliloginlayer.dispatchCustomEvent('uli-login-layer-open', '');
            },
            openPwr: function (e) {
                if (
                    window.Check24.uliloginlayer.useAppOpener &&
                    window.Check24.uliloginlayer.config.params.deviceoutput === 'tabletapp'
                ) {
                    window.Check24.uliloginlayer.openInApp();
                    return;
                }
                window.Check24.uliloginlayer.isOpen = true;
                window.Check24.uliloginlayer.beforeOpen();
                if (e) {
                    e.target.nodeName === 'A' ? e.preventDefault() : {};
                }
                window.Check24.uliloginlayer.historyCount = 0;
                window.Check24.uliloginlayer.config.params.mode = 'pwreset';
                window.Check24.uliloginlayer.setAttributeData(e);
                window.Check24.uliloginlayer.addLayer();
            },
            openRegister: function (e) {
                if (
                    window.Check24.uliloginlayer.useAppOpener &&
                    window.Check24.uliloginlayer.config.params.deviceoutput === 'tabletapp'
                ) {
                    window.Check24.uliloginlayer.openInApp();
                    return;
                }
                window.Check24.uliloginlayer.beforeOpen();
                if (e) {
                    e.target.nodeName === 'A' ? e.preventDefault() : {};
                }
                window.Check24.uliloginlayer.historyCount = 0;
                window.Check24.uliloginlayer.config.params.mode = 'register';
                window.Check24.uliloginlayer.setAttributeData(e);
                window.Check24.uliloginlayer.addLayer();
            },
            setAttributeData: function (e) {
                if (e && e.target && e.target.dataset && e.target.dataset.email && e.target.dataset.email !== '') {
                    window.Check24.uliloginlayer.config.params.login_email = e.target.dataset.email;
                }
                if (e && e.target && e.target.dataset && e.target.dataset.phone && e.target.dataset.phone !== '') {
                    window.Check24.uliloginlayer.config.params.login_phone = e.target.dataset.phone;
                }
                if (e && e.target && e.target.dataset && e.target.dataset.type && e.target.dataset.type !== '') {
                    window.Check24.uliloginlayer.config.params.login_type = e.target.dataset.type;
                }
            },
            addLayer: function () {
                var iframe = document.querySelector('.c24-uli-loginlayer-iframe');
                iframe.contentWindow.location.replace(window.Check24.uliloginlayer.getIframeUrl());
                window.Check24.addClass('.c24-uli-loginlayer-iframe', 'c24-ulill-connected');
                iframe.addEventListener('load', window.Check24.uliloginlayer.iframeLoaded);
                var top = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                if (window.Check24.uliloginlayer.config.params.deviceoutput === 'desktop') {
                    if (document.documentElement.scrollHeight - top < 520) {
                        document.querySelector('.c24-uli-loginlayer').style.top = 'initial';
                        document.querySelector('.c24-uli-loginlayer').style.bottom = '150px';
                    } else {
                        document.querySelector('.c24-uli-loginlayer').style.bottom = 'initial';
                        document.querySelector('.c24-uli-loginlayer').style.top = top + 110 + 'px';
                    }
                    document.querySelector('.c24-blocking-layer').style.height =
                        document.documentElement.scrollHeight + 'px';
                    document.querySelector('.c24-blocking-layer').style.display = 'block';
                } else if (window.Check24.uliloginlayer.config.params.deviceoutput === 'mobile') {
                    document.querySelector('#c24m-page').classList.remove('c24m-cookie-animate');
                    document.querySelector('#c24m-page').style.overflowY = 'hidden';
                    if (typeof window.C24M.navi.close === 'function') {
                        window.C24M.navi.close();
                    }
                }
            },
            iframeLoaded: function () {
                window.Check24.uliloginlayer.historyPush();
                window.Check24.uliloginlayer.dataPush = false;
                document.querySelector('.c24-uli-loginlayer').style.display = 'block';
            },
            closeDefault: function () {
                var iframe = document.querySelector('.c24-uli-loginlayer-iframe').contentWindow;
                iframe.postMessage('layerClosed', window.Check24.uliloginlayer.getIframeBaseUrl());
                window.Check24.addClass('.c24-uli-loginlayer-iframe', 'c24-ulill-waitforclose');
                setTimeout(function () {
                    window.Check24.removeClass('.c24-uli-loginlayer-iframe', 'c24-ulill-waitforclose');
                }, 3000);
                window.Check24.removeClass('.c24-uli-loginlayer-iframe', 'c24-ulill-connected');
                document.querySelector('.c24-blocking-layer').style.display = 'none';
                document.querySelector('.c24-uli-loginlayer').style.display = 'none';
                window.Check24.uliloginlayer.isOpen = false;
                window.Check24.uliloginlayer.closeDefaultAfter();
                window.Check24.uliloginlayer.dispatchCustomEvent('uli-login-layer-close', '');
                window.Check24.uliloginlayer.config.opener = '';
            },
            closeDefaultAfter: function () {},
            close: function (data) {
                if (window.Check24.uliloginlayer.config.params.deviceoutput === 'desktop') {
                    document.querySelector('.c24-blocking-layer').style.display = 'none';
                } else if (window.Check24.uliloginlayer.config.params.deviceoutput === 'mobile') {
                    if (window.C24M.cookieBanner.visible) {
                        document.querySelector('#c24m-page').classList.add('c24m-cookie-animate');
                    }
                    document.querySelector('#c24m-page').style.overflowY = 'visible';
                    document.querySelector('#c24m-page').style.height = 'auto';
                }
                window.Check24.removeClass('.c24-uli-loginlayer-iframe', 'c24-ulill-connected');
                document.querySelector('.c24-uli-loginlayer').style.display = 'none';
                window.Check24.uliloginlayer.isOpen = false;

                if (
                    typeof data !== 'undefined' &&
                    (!data.hasOwnProperty('OPENER') || (data.hasOwnProperty('OPENER') && data.OPENER === ''))
                ) {
                    window.Check24.uliloginlayer.closeAfter(data);
                    window.Check24.uliloginlayer.dispatchCustomEvent('uli-login-layer-close', data);
                }
            },
            closeAfter: function (data) {},
            browserBackRequest: function () {
                if (document.querySelector('.c24-uli-loginlayer-iframe')) {
                    var iframe = document.querySelector('.c24-uli-loginlayer-iframe').contentWindow;
                    if (window.Check24.hasClass('.c24-uli-loginlayer-iframe', 'c24-ulill-connected')) {
                        iframe.postMessage('browserback', window.Check24.uliloginlayer.getIframeBaseUrl());
                    }
                }
            },
            historyPushed: false,
            historyCount: 0,
            historyID: 0,
            useHistoryPush: true,
            historyPush: function () {
                window.Check24.uliloginlayer.historyID++;
                if (window.Check24.uliloginlayer.historyCount < 3 && window.Check24.uliloginlayer.useHistoryPush) {
                    window.Check24.uliloginlayer.historyCount++;
                    window.history.pushState(
                        {
                            action: 'open' + window.Check24.uliloginlayer.historyID,
                            origin: 'loginlayer',
                        },
                        '',
                        window.location,
                    );
                }
            },
            listenToPopState: true,
            onPopState: function () {
                if (window.Check24.uliloginlayer.listenToPopState) {
                    window.Check24.uliloginlayer.historyCount--;
                    window.Check24.uliloginlayer.browserBackRequest();
                }
            },
            tryParseJSON: function (jsonString) {
                try {
                    var o = JSON.parse(jsonString);
                    if (o && typeof o === 'object') {
                        return o;
                    }
                } catch (e) {}
                return false;
            },
            handleUlDocMsg: function (e) {
                if (e.data) {
                    var eventData = window.Check24.uliloginlayer.tryParseJSON(e.data);
                    var data = typeof eventData.ul !== 'undefined' ? eventData.ul : false;
                    var view = typeof eventData.uli_view !== 'undefined' ? eventData.uli_view : false;
                    if (data) {
                        if (data.docHeight) {
                            if (document.querySelector('.c24-uli-loginlayer-iframe')) {
                                document.querySelector('.c24-uli-loginlayer-iframe').style.height =
                                    data.docHeight + 'px';
                            }
                            if (window.Check24.uliloginlayer.config.params.deviceoutput === 'mobile') {
                                var uliHeight = data.docHeight + 50;
                                if (uliHeight > window.innerHeight) {
                                    document.querySelector('#c24m-page').style.height = uliHeight + 'px';
                                } else {
                                    document.querySelector('#c24m-page').style.height = window.innerHeight + 'px';
                                }
                            }
                            return;
                        }
                        window.Check24.uliloginlayer.handleUserData(data);
                    }

                    if (view) {
                        var uliViewEvent = new CustomEvent('unified-login-view', {
                            detail: {
                                uli_view: view,
                            },
                        });
                        if (uliViewEvent instanceof Event) {
                            window.dispatchEvent(uliViewEvent);
                        }
                    }
                }
            },
            dataPush: false,
            handleUserData: function (data) {
                if (
                    (data.USEREMAIL || data.USERPHONE) &&
                    data.STATE !== 'loggedin' &&
                    data.STATE !== 'browserback' &&
                    !window.Check24.uliloginlayer.dataPush
                ) {
                    window.removeEventListener('popstate', window.Check24.uliloginlayer.onPopState);
                    window.addEventListener('popstate', window.Check24.uliloginlayer.onPopState);
                    window.Check24.uliloginlayer.historyPush();
                    window.Check24.uliloginlayer.dataPush = true;
                }

                if (!data.hasOwnProperty('STATE') || data.STATE === '') {
                    return;
                }

                window.Check24.uliloginlayer.responseData = data;
                data.OPENER = window.Check24.uliloginlayer.config.opener;

                if (
                    document.querySelector('.c24-uli-loginlayer') &&
                    (document.querySelector('.c24-uli-loginlayer').style.display === 'block' ||
                        window.Check24.hasClass('.c24-uli-loginlayer-iframe', 'c24-ulill-waitforclose'))
                ) {
                    window.Check24.removeClass('.c24-uli-loginlayer-iframe', 'c24-ulill-waitforclose');
                    window.Check24.uliloginlayer.close(data);
                }

                if (window.Check24.uliloginlayer.config.opener !== '') {
                    window.Check24.uliloginlayer.dispatchCustomEvent(
                        'uli-login-layer-' + window.Check24.uliloginlayer.config.opener,
                        data,
                    );
                    window.Check24.uliloginlayer.config.opener = '';
                    return;
                }

                window.Check24.uliloginlayer.dispatchCustomEvent('uli-login-layer', data);
            },
            dispatchCustomEvent: function (name, data) {
                var eventName = typeof name !== 'undefined' && name !== '' ? name : 'uli-login-layer';
                var eventData = typeof data !== 'undefined' && data !== '' ? data : '';
                var uliloginlayerEvent = new CustomEvent(eventName, {
                    detail: {
                        ul: eventData,
                        origin: 'loginlayer',
                    },
                });
                if (uliloginlayerEvent instanceof Event) {
                    window.dispatchEvent(uliloginlayerEvent);
                }
            },
            openerEvent: function (e) {
                try {
                    window.Check24.uliloginlayer.config.opener = '';
                    var data = e.detail.ul;
                    data.OPENER = '';
                    window.Check24.uliloginlayer.dispatchCustomEvent('uli-login-layer', data);
                    window.Check24.uliloginlayer.closeAfter(data);
                } catch (e) {
                    window.Check24.uliloginlayer.closeAfter(window.Check24.uliloginlayer.responseData);
                }
            },
        };
        window.Check24 = window.Check24 || {};
        window.Check24.uli = {
            url: 'https://anmelden.check24.de/laststable?json',
            init: function () {
                var uri = window.Check24.uli.url;
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status !== 200) {
                            window.Check24.uli.globalError();
                        }
                    } else {
                        window.Check24.uli.globalError();
                    }
                };
                xhr.onerror = function () {
                    window.Check24.uli.globalError();
                };
                xhr.open('GET', uri, true);
                xhr.send();
            },
            globalError: function () {
                // fill hidden input
                if (document.getElementById('c24-ul-user-state')) {
                    document.getElementById('c24-ul-user-state').value = 'anonymous';
                }
                // trigger anonymous function
                if (typeof C24ulpf !== 'undefined' && typeof C24ulpf.userAnonymous === 'function') {
                    C24ulpf.userAnonymous();
                }
                // trigger data function
                if (typeof C24ulpf !== 'undefined' && typeof C24ulpf.getUserData === 'function') {
                    C24ulpf.getUserData({
                        USERLOGIN: '',
                        USERPHONE: '',
                        USEREMAIL: '',
                        USERPOINTS: '',
                        STATE: 'anonymous',
                    });
                }
                // trigger custom event
                var ulEvent = new CustomEvent('unified-login', {
                    detail: {
                        ul: {
                            USERLOGIN: '',
                            USERPHONE: '',
                            USEREMAIL: '',
                            USERPOINTS: '',
                            STATE: 'anonymous',
                        },
                    },
                });
                if (ulEvent instanceof Event) {
                    window.dispatchEvent(ulEvent);
                }
            },
        };
        ('use strict');

        function ownKeys(object, enumerableOnly) {
            var keys = Object.keys(object);
            if (Object.getOwnPropertySymbols) {
                var symbols = Object.getOwnPropertySymbols(object);
                enumerableOnly &&
                    (symbols = symbols.filter(function (sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    })),
                    keys.push.apply(keys, symbols);
            }
            return keys;
        }

        function _objectSpread(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = null != arguments[i] ? arguments[i] : {};
                i % 2
                    ? ownKeys(Object(source), !0).forEach(function (key) {
                          _defineProperty(target, key, source[key]);
                      })
                    : Object.getOwnPropertyDescriptors
                      ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source))
                      : ownKeys(Object(source)).forEach(function (key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
            }
            return target;
        }

        function _defineProperty(obj, key, value) {
            if (key in obj) {
                Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
            } else {
                obj[key] = value;
            }
            return obj;
        }

        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
                throw new TypeError('Cannot call a class as a function');
            }
        }

        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ('value' in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        function _createClass(Constructor, protoProps, staticProps) {
            if (protoProps) _defineProperties(Constructor.prototype, protoProps);
            if (staticProps) _defineProperties(Constructor, staticProps);
            Object.defineProperty(Constructor, 'prototype', { writable: false });
            return Constructor;
        }

        /**
         * @typedef SupportDialogHandler
         * @type {Function}
         * @return {boolean} true in case handled otherwise false
         */

        /**
         * Official App-JavaScript bridge
         *
         * See https://confluence.check24.de/display/C24APPS/JavaScript+Interface
         *
         * @type window.C24App
         */
        window.C24App = /*#__PURE__*/ (function () {
            function C24App() {
                _classCallCheck(C24App);
            }

            _createClass(C24App, null, [
                {
                    key: 'setErrorHandler',
                    value:
                        /**
                         * Will be invoked by the App in error cases.
                         * @function C24App#setErrorHandler
                         *
                         * @param handler
                         */
                        function setErrorHandler(handler) {
                            this._errorHandler = handler;
                        },
                    /**
                     * Register a handler that will be invoked by the App if a support dialog should be shown
                     * @function C24App#setSupportDialogHandler
                     *
                     * @param {SupportDialogHandler} handler
                     */
                },
                {
                    key: 'setSupportDialogHandler',
                    value: function setSupportDialogHandler(handler) {
                        this._supportDialogHandler = handler;
                    },
                    /**
                     * Set current product SSO key
                     * @function C24App#setProduct
                     *
                     * @param config        Either: The SSO product key as a string (deprecated), or an object containing 'productSSO' and optionally a 'title'
                     * @param completion    The callback for the result
                     */
                },
                {
                    key: 'setProduct',
                    value: function setProduct(config, completion) {
                        if (config === null) return;

                        if (typeof config === 'string') {
                            config = {
                                productSSO: config,
                            };
                        }

                        this.setCallback('setProduct', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            var message = Object.assign(config, {
                                method: 'setProduct',
                            });
                            window.webkit.messageHandlers.appBridge.postMessage(message);
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            if (typeof appBridge.setProductConfig === 'undefined') {
                                appBridge.setProduct(config.productSSO);
                            } else {
                                appBridge.setProductConfig(JSON.stringify(config));
                            }
                        }
                    },
                    /**
                     * Callback from setProductSSO
                     *
                     * @param result    boolean
                     * @param message   A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'setProductCompletion',
                    value: function setProductCompletion(result, message) {
                        this.callback('setProduct', result, message);
                    },
                    /**
                     * Tracks a conversion funnel event.
                     * @function C24App#trackConversionFunnel
                     *
                     * @param config        The config
                     * @param completion    The callback for the result
                     */
                },
                {
                    key: 'trackConversionFunnel',
                    value: function trackConversionFunnel(config, completion) {
                        // Check if deprecated function signature is used
                        if (arguments.length >= 3) {
                            config = {
                                productSSO: arguments[0],
                                voucherCode: arguments[1],
                            };
                            completion = arguments[2];
                        } // Set callback

                        this.setCallback('trackConversionFunnel', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            var message = Object.assign(config, {
                                method: 'trackConversionFunnel',
                                step: 'Conversion',
                            });
                            window.webkit.messageHandlers.appBridge.postMessage(message);
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            if (appBridge.trackConversionFunnelWithConfig) {
                                appBridge.trackConversionFunnelWithConfig('Conversion', JSON.stringify(config));
                            } else if (appBridge.trackConversionFunnel) {
                                // call old method
                                appBridge.trackConversionFunnel('Conversion', config.productSSO, config.voucherCode);
                            }
                        }
                    },
                    /**
                     * Callback from trackConversionFunnel
                     *
                     * @param result    boolean
                     * @param message   A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'trackConversionFunnelCompletion',
                    value: function trackConversionFunnelCompletion(result, message) {
                        this.callback('trackConversionFunnel', result, message);
                    },
                    /**
                     * Triggers Chatty with given parameters
                     * @function C24App#triggerChatty
                     *
                     * @param chatFlowName      string
                     * @param chatFlowEntry     string
                     * @param chatFlowRelease   string
                     * @param modal             bool
                     * @param completion        function
                     */
                },
                {
                    key: 'triggerChatty',
                    value: function triggerChatty(chatFlowName) {
                        var chatFlowEntry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';
                        var chatFlowRelease =
                            arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'active';
                        var modal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                        var completion = arguments.length > 4 ? arguments[4] : undefined;
                        this.triggerChattyWithOptions(
                            {
                                chatFlowName: chatFlowName,
                                chatFlowEntry: chatFlowEntry,
                                chatFlowRelease: chatFlowRelease,
                                modal: modal,
                            },
                            completion,
                        );
                    },
                    /**
                     * Callback from triggerChatty
                     *
                     * @param result    boolean
                     * @param message   A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'triggerChattyCompletion',
                    value: function triggerChattyCompletion(result, message) {
                        this.callback('triggerChatty', result, message);
                    },
                    /**
                     * @typedef {object} TriggerChattyOptions
                     * @property {string} chatFlowName
                     * @property {string} [chatFlowEntry="start"]
                     * @property {string} [chatFlowRelease="active"]
                     * @property {object} [clientDetails=]
                     * @property {boolean} [modal=true]
                     * @property {"sheet"|"dialog"} [presentationType="sheet"]
                     * @property {ChattySheetState} [sheetState="half"]
                     */

                    /**
                     * @typedef {"minimized"|"half"|"full"} ChattySheetState
                     */

                    /**
                     * Triggers Chatty with given parameters
                     * @function C24App#triggerChattyWithOptions
                     *
                     * @param {TriggerChattyOptions}          options             Options for push chatty
                     * @param {function|null}                 completion          The callback for the result
                     */
                },
                {
                    key: 'triggerChattyWithOptions',
                    value: function triggerChattyWithOptions(options, completion) {
                        var _options$chatFlowEntr,
                            _options$chatFlowRele,
                            _options$modal,
                            _options$presentation,
                            _options$sheetState;

                        options.chatFlowEntry =
                            (_options$chatFlowEntr = options.chatFlowEntry) !== null && _options$chatFlowEntr !== void 0
                                ? _options$chatFlowEntr
                                : 'start';
                        options.chatFlowRelease =
                            (_options$chatFlowRele = options.chatFlowRelease) !== null &&
                            _options$chatFlowRele !== void 0
                                ? _options$chatFlowRele
                                : 'active';
                        options.modal =
                            (_options$modal = options.modal) !== null && _options$modal !== void 0
                                ? _options$modal
                                : true;
                        options.presentationType =
                            (_options$presentation = options.presentationType) !== null &&
                            _options$presentation !== void 0
                                ? _options$presentation
                                : 'sheet';
                        options.sheetState =
                            (_options$sheetState = options.sheetState) !== null && _options$sheetState !== void 0
                                ? _options$sheetState
                                : 'half';

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Set callback
                            this.setCallback('triggerChatty', completion); // Invoke bridge method

                            window.webkit.messageHandlers.appBridge.postMessage(
                                _objectSpread(
                                    _objectSpread({}, options),
                                    {},
                                    {
                                        method: 'triggerChatty',
                                    },
                                ),
                            );
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            if (
                                typeof options.chatFlowName === 'string' &&
                                typeof options.chatFlowEntry === 'string' &&
                                typeof options.chatFlowRelease === 'string'
                            ) {
                                if (appBridge.triggerChattyWithOptions) {
                                    // Set callback
                                    this.setCallback('triggerChattyWithOptions', completion);
                                    options.clientDetails = options.clientDetails
                                        ? JSON.stringify(options.clientDetails)
                                        : null;
                                    options.modal = options.modal ? 'true' : 'false';
                                    appBridge.triggerChattyWithOptions(JSON.stringify(options));
                                } else if (appBridge.triggerChatty) {
                                    // set "old" callback in order to have it called by "old" trigger function
                                    this.setCallback('triggerChatty', completion); // call old trigger method

                                    appBridge.triggerChatty(
                                        options.chatFlowName,
                                        options.chatFlowEntry,
                                        options.chatFlowRelease,
                                        options.modal,
                                    );
                                }
                            }
                        }
                    },
                    /**
                     * Callback from triggerChattyWithOptions
                     *
                     * @param result    boolean
                     * @param message   A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'triggerChattyWithOptionsCompletion',
                    value: function triggerChattyWithOptionsCompletion(result, message) {
                        this.callback('triggerChattyWithOptions', result, message);
                    },
                    /**
                     * Set current sheet state of Chatty.
                     * Only supported if Chatty was started with {@link TriggerChattyOptions#presentationType} = "sheet"
                     *
                     * @function C24App#setChattySheetState
                     *
                     * @param {ChattySheetState} sheetState state chatty should set to
                     * @param                    completion function
                     */
                },
                {
                    key: 'setChattySheetState',
                    value: function setChattySheetState(sheetState, completion) {
                        // Set callback
                        this.setCallback('setChattySheetState', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            window.webkit.messageHandlers.appBridge.postMessage({
                                sheetState: sheetState,
                                method: 'setChattySheetState',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable() && appBridge.setChattySheetState) {
                            appBridge.setChattySheetState(sheetState);
                        }
                    },
                    /**
                     * Callback from setChattySheetState
                     *
                     * @param result    boolean
                     * @param message   A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'setChattySheetStateCompletion',
                    value: function setChattySheetStateCompletion(result, message) {
                        this.callback('setChattySheetState', result, message);
                    },
                    /**
                     * Send context to the current Chatty instance
                     *
                     * @function C24App#sendContextToChatty
                     *
                     * @param {object}      context to be passed to Chatty
                     * @param {function}    completion Completion handler with result (and error message in debug builds)
                     */
                },
                {
                    key: 'sendContextToChatty',
                    value: function sendContextToChatty(context, completion) {
                        // Set callback
                        this.setCallback('sendContextToChatty', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            window.webkit.messageHandlers.appBridge.postMessage({
                                context: context,
                                method: 'sendContextToChatty',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable() && appBridge.sendContextToChatty) {
                            appBridge.sendContextToChatty(JSON.stringify(context));
                        }
                    },
                    /**
                     * Callback from sendContextToChatty
                     *
                     * @param result    boolean
                     * @param message   A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'sendContextToChattyCompletion',
                    value: function sendContextToChattyCompletion(result, message) {
                        this.callback('sendContextToChatty', result, message);
                    },
                    /**
                     * Method to be called by the app in case new context was received from Chatty
                     *
                     * To receive Chatty context as web view:
                     * @example
                     *   window.window.addEventListener("didReceiveContextFromChatty", (e) => ;
                     *
                     * @function C24App#didReceiveContextFromChatty
                     *
                     * @param {object} context sent by Chatty
                     */
                },
                {
                    key: 'didReceiveContextFromChatty',
                    value: function didReceiveContextFromChatty(context) {
                        window.document.dispatchEvent(
                            new CustomEvent('didReceiveContextFromChatty', {
                                detail: {
                                    context: context,
                                },
                            }),
                        );
                    },
                    /**
                     * Gets the chatty sheet state (full|half|minimized) if a chatty sheet is open, or null if no chatty is open
                     * @function C24App#getChattySheetState
                     *
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'getChattySheetState',
                    value: function getChattySheetState(completion) {
                        this.setCallback('getChattySheetStateCompletion', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'getChattySheetState',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.getChattySheetState();
                        }
                    },
                    /**
                     * Completion for getChattySheetState
                     *
                     * @param {ChattySheetState|null} state   (full|half|minimized) if a chatty sheet is open, or null if no chatty is open
                     * @param {string|null} message  Will provide additional information in Alpha apps if result is false
                     */
                },
                {
                    key: 'getChattySheetStateCompletion',
                    value: function getChattySheetStateCompletion(state, message) {
                        this.callback('getChattySheetStateCompletion', state, message);
                    },
                    /**
                     * Closes the Chatty sheet if there is one open
                     * @function C24App#closeChattySheet
                     *
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'closeChattySheet',
                    value: function closeChattySheet(completion) {
                        this.setCallback('closeChattySheetCompletion', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'closeChattySheet',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable() && appBridge.closeChattySheet) {
                            appBridge.closeChattySheet();
                        }
                    },
                    /**
                     * Completion for closeChattySheet
                     * @function C24App#closeChattySheetCompletion
                     *
                     * @param {boolean}     success Will be true if trigger has been received successfully
                     * @param {string|null} message Will provide additional information in Alpha apps if result is false
                     */
                },
                {
                    key: 'closeChattySheetCompletion',
                    value: function closeChattySheetCompletion(success, message) {
                        this.callback('closeChattySheetCompletion', success, message);
                    },
                    /**
                     * Method to be called by the app in case a Chatty Sheet is opened
                     *
                     * To receive as web view:
                     * @example
                     *   window.window.addEventListener("didChangeChattySheetState", (e) => ;
                     *
                     * @function C24App#didOpenChattySheet
                     */
                },
                {
                    key: 'didOpenChattySheet',
                    value: function didOpenChattySheet() {
                        window.document.dispatchEvent(new CustomEvent('didOpenChattySheet'));
                    },
                    /**
                     * Method to be called by the app in case a Chatty Sheet is closed
                     *
                     * To receive as web view:
                     * @example
                     *   window.window.addEventListener("didCloseChatty", (e) => ;
                     *
                     * @function C24App#didOpenChatty
                     */
                },
                {
                    key: 'didCloseChattySheet',
                    value: function didCloseChattySheet() {
                        window.document.dispatchEvent(new CustomEvent('didCloseChattySheet'));
                    },
                    /**
                     * Method to be called by the app in case the Chatty Sheet State has changed
                     *
                     * To receive as web view:
                     * @example
                     *   window.window.addEventListener("didChangeChattySheetState", (e) => ;
                     *
                     * @function C24App#didChangeChattySheetState
                     *
                     * @param sheetState {ChattySheetState}
                     */
                },
                {
                    key: 'didChangeChattySheetState',
                    value: function didChangeChattySheetState(sheetState) {
                        window.document.dispatchEvent(
                            new CustomEvent('didChangeChattySheetState', {
                                detail: {
                                    sheetState: sheetState,
                                },
                            }),
                        );
                    },
                    /**
                     * @typedef {object} ModalWebConfiguration
                     * @property {string} url
                     * @property {ModalWebSheet|ModalWebFullscreen} presentation
                     * @property {string|null} [backgroundColor] Color as hex string. Defaults to `#ffffff`.
                     * @property {boolean|null} [handleCloseEvent] Defaults to `false`. If set to `true` an `modalWebViewClose` will be sent with the url passed from the modal web view in `event.detail.url`
                     */

                    /**
                     * @typedef {object} ModalWebFullscreen
                     * @property {"fullscreen"} type
                     * @property {ModalWebCloseButton} closeButton
                     */

                    /**
                     * @typedef {object} ModalWebCloseButton
                     * @property {boolean|null} [isHidden] Defaults to `false`.
                     * @property {string|null} [color] Defaults to #666666.
                     */

                    /**
                     * @typedef {object} ModalWebSheet
                     * @property {"sheet"} type
                     * @property {"half"|"full"} state
                     */

                    /**
                     * Opens a modal web view with the provided `configuration`
                     *
                     * @param configuration {ModalWebConfiguration}
                     * @param completion {function|null}
                     */
                },
                {
                    key: 'openModalWebView',
                    value: function openModalWebView(configuration, completion) {
                        this.setCallback('openModalWebView', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            var message = Object.assign(configuration, {
                                method: 'openModalWebView',
                            });
                            window.webkit.messageHandlers.appBridge.postMessage(message);
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            if (typeof appBridge.openModalWebView === 'function') {
                                appBridge.openModalWebView(JSON.stringify(configuration));
                            } else {
                                this.openModalWebViewCompletion(false, 'Not available');
                            }
                        }
                    },
                    /**
                     * Callback from openModalWebView
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only sent in Alpha apps
                     */
                },
                {
                    key: 'openModalWebViewCompletion',
                    value: function openModalWebViewCompletion(result, message) {
                        this.callback('openModalWebView', result, message);
                    },
                    /**
                     * Disables header is hiding when scrolling in WebView (Android only).
                     * It will be enabled automatically again after the next page load.
                     * @function C24App#setHeaderScrollingDisabled
                     *
                     * @param disabled      true if the header scrolling should be disabled, false if it should be enabled
                     */
                },
                {
                    key: 'setHeaderScrollingDisabled',
                    value: function setHeaderScrollingDisabled() {
                        var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                        if (
                            window.C24App.isAndroidBridgeAvailable() &&
                            disabled !== null &&
                            typeof disabled === 'boolean' &&
                            typeof appBridge.setHeaderScrollingDisabled !== 'undefined'
                        ) {
                            appBridge.setHeaderScrollingDisabled(disabled);
                        }
                    },
                    /**
                     * Callback from setHeaderScrollingDisabled
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'setHeaderScrollingDisabledCompletion',
                    value: function setHeaderScrollingDisabledCompletion(result, message) {
                        this.callback('setHeaderScrollingDisabled', result, message);
                    },
                    /**
                     * Calls an unified login from webview. It will open a module login dialog inside the app according to the
                     * configuration and pre-filling provided.
                     * @function C24App#triggerUnifiedLogin
                     *
                     * @param {string} configurationType configuration type / transactionType to the current productId to modify the UL
                     *                                   displayed accordingly
                     * @param {string|null} email             email to be pre-filled
                     * @param {string|null} custom_param      product specific param to be passed towards Points-Xtreme backend
                     * @param {string|null} productSSO
                     */
                },
                {
                    key: 'triggerUnifiedLogin',
                    value: function triggerUnifiedLogin() {
                        var configurationType =
                            arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
                        var email = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                        var custom_param = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                        var productSSO = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                        this.triggerUnifiedLoginWithOptions({
                            configurationType: configurationType,
                            email: email,
                            custom_param: custom_param,
                            productSSO: productSSO,
                        });
                    },
                    /**
                     * @typedef {object} TriggerUnifiedLoginOptions
                     * @property {string} [configurationType="default"]
                     * @property {string|null} email
                     * @property {string|null} custom_param
                     * @property {string|null} productSSO
                     * @property {string|null} bannerUrl
                     * @property {boolean|null} allowRelogin
                     */

                    /**
                     * Calls a unified login from webview. It will open a module login dialog inside the app according to the
                     * configuration and pre-filling provided.
                     * @function C24App#triggerUnifiedLogin
                     *
                     * @param {TriggerUnifiedLoginOptions} options
                     */
                },
                {
                    key: 'triggerUnifiedLoginWithOptions',
                    value: function triggerUnifiedLoginWithOptions(options) {
                        var _options$configuratio;

                        var configurationType =
                            (_options$configuratio = options.configurationType) !== null &&
                            _options$configuratio !== void 0
                                ? _options$configuratio
                                : 'default';
                        var email = options.email;
                        var custom_param = options.custom_param;
                        var productSSO = options.productSSO;
                        var bannerUrl = options.bannerUrl;
                        var allowRelogin = options.allowRelogin;

                        if (
                            configurationType !== null &&
                            typeof configurationType === 'string' &&
                            (email === null || typeof email === 'string')
                        ) {
                            if (window.C24App.isiOSBridgeAvailable()) {
                                // Indicate triggerUnifiedLogin was invoked.
                                // Needed to identify error reason in case of iOS
                                this.unifiedLoginTriggered = true; // Invoke bridge method

                                window.webkit.messageHandlers.appBridge.postMessage({
                                    method: 'triggerUnifiedLogin',
                                    configurationType: configurationType,
                                    email: email !== null ? email : '',
                                    custom_param: custom_param !== null ? custom_param : '',
                                    productSSO: productSSO,
                                    bannerUrl: bannerUrl,
                                    allowRelogin: allowRelogin,
                                });
                            } else if (window.C24App.isAndroidBridgeAvailable()) {
                                // Check if unified login enabled version available
                                if (
                                    typeof appBridge.triggerUnifiedLogin === 'undefined' &&
                                    typeof appBridge.triggerUnifiedLoginWithOptions === 'undefined'
                                ) {
                                    this.onUnifiedLoginError();
                                    return;
                                }

                                if (typeof appBridge.triggerUnifiedLoginWithOptions === 'undefined') {
                                    try {
                                        appBridge.triggerUnifiedLogin(
                                            configurationType,
                                            email,
                                            custom_param,
                                            productSSO,
                                        );
                                    } catch (error) {
                                        appBridge.triggerUnifiedLogin(configurationType, email, custom_param);
                                    }
                                } else {
                                    appBridge.triggerUnifiedLoginWithOptions(
                                        JSON.stringify(
                                            _objectSpread(
                                                _objectSpread({}, options),
                                                {},
                                                {
                                                    customParam: custom_param,
                                                },
                                            ),
                                        ),
                                    );
                                }
                            }
                        }
                    },
                    /**
                     * Calls a login modal from webview. It will open a module login dialog inside the app according to the pre-filling provided.
                     * @function C24App#triggerLoginModal
                     *
                     * @param {string|null} username       email or phone to be pre-filled
                     * @param {string|null} loginType      preferred login step: 'login', 'register', 'reset_password'
                     * @param {boolean} allowRelogin       defines is re-login is allowed
                     * @param {string|null} loginText      overrides the default login text
                     */
                },
                {
                    key: 'triggerLoginModal',
                    value: function triggerLoginModal() {
                        var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
                        var loginType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'login';
                        var allowRelogin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var loginText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

                        if (
                            username === null ||
                            (typeof username === 'string' &&
                                (loginType === null || typeof loginType === 'string') &&
                                (loginText === null || typeof loginText === 'string') &&
                                typeof allowRelogin == 'boolean')
                        ) {
                            if (window.C24App.isiOSBridgeAvailable()) {
                                // Indicate triggerUnifiedLogin was invoked.
                                // Needed to identify error reason in case of iOS
                                this.unifiedLoginTriggered = true; // Invoke bridge method

                                window.webkit.messageHandlers.appBridge.postMessage({
                                    method: 'triggerLoginModal',
                                    username: username !== null ? username : '',
                                    loginType: loginType !== null ? loginType : '',
                                    allowRelogin: allowRelogin,
                                    loginText: loginText !== null ? loginText : '',
                                });
                            } else if (window.C24App.isAndroidBridgeAvailable()) {
                                // Check if login modal available.
                                // If not trigger unified login error to notify the caller.
                                if (typeof appBridge.triggerLoginModal === 'undefined') {
                                    this.onUnifiedLoginError();
                                    return;
                                }

                                appBridge.triggerLoginModal(username, loginType, allowRelogin, loginText);
                            }
                        }
                    },
                    /**
                     * Use this function to update user data inside App.
                     * CAUTION: This method is restricted to selected products only!
                     */
                },
                {
                    key: 'triggerPing',
                    value: function triggerPing() {
                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'triggerPing',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.triggerPing();
                        }
                    },
                    /**
                     * @typedef PushPermissionDialogOptions
                     * @type {object}
                     * @property {string} notificationTitle
                     * @property {string} notificationText
                     * @property {string|null} notificationImageURL
                     * @property {string} explanationTitle
                     * @property {string} explanationText
                     * @property {string|null} productSSO
                     */

                    /**
                     * Triggers push permission dialog
                     *
                     * The number of times the dialog can be presented is limited. Pass a completion handler to check if the dialog was actually presented.
                     *
                     * The currently available options for the push permission dialog are:
                     * - notificationTitle (string)
                     * - notificationText  (string)
                     * - notificationImageURL (string) (optional)
                     * - explanationTitle (string)
                     * - explanationText (string)
                     *
                     * @function C24App#triggerPushPermissionDialog
                     *
                     * @param {PushPermissionDialogOptions}   options             Options for push permission dialog
                     * @param {function|null}                 completion          The callback for the result
                     *
                     */
                },
                {
                    key: 'triggerPushPermissionDialog',
                    value: function triggerPushPermissionDialog(options, completion) {
                        // Check if deprecated function signature is used
                        if (arguments.length >= 4) {
                            var notificationTitle = arguments[0];
                            var notificationText = arguments[1];
                            var explanationTitle = arguments[2];
                            var explanationText = arguments[3];
                            var _completion = arguments[4]; // Set callback

                            this.setCallback('triggerPushPermissionDialog', _completion);

                            if (window.C24App.isiOSBridgeAvailable()) {
                                // Invoke bridge method
                                window.webkit.messageHandlers.appBridge.postMessage({
                                    method: 'triggerPushPermissionDialog',
                                    notificationTitle: notificationTitle,
                                    notificationText: notificationText,
                                    explanationTitle: explanationTitle,
                                    explanationText: explanationText,
                                });
                            }
                        } else {
                            // Set callback
                            this.setCallback('triggerPushPermissionDialog', completion);

                            if (window.C24App.isiOSBridgeAvailable()) {
                                // Create message from options and method
                                var message = Object.assign(options, {
                                    method: 'triggerPushPermissionDialog',
                                }); // Invoke bridge method

                                window.webkit.messageHandlers.appBridge.postMessage(message);
                            } else if (window.C24App.isAndroidBridgeAvailable()) {
                                appBridge.triggerPushPermissionDialog(JSON.stringify(options));
                            }
                        }
                    },
                    /**
                     * Callback from triggerPushPermissionDialog
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'triggerPushPermissionDialogCompletion',
                    value: function triggerPushPermissionDialogCompletion(result, message) {
                        this.callback('triggerPushPermissionDialog', result, message);
                    },
                    /**
                     * Called by the app when an user was logged in successfully via native Unified Login
                     *
                     * @param {"email"|"phone"}                       userlogin    logged in by "email" or "phone"
                     * @param {string|null}                           phone        phonenumber the user has entered
                     * @param {string|null}                           email        email the user has entered
                     * @param {"false"|"true"|"yes"|"no"}             points       "false" (product didn't set points-parameter/-attribute to
                     *                                                            "radio" or "checkbox"), "true" (user is already points-user),
                     *                                                            "yes"/"no" (onwer of no-points-user)
                     * @param {"login"|"register"|null}               logintype   type of login ("register", "login", null (in case of anonymous))
                     * @param {"loggedin"|"anonymous"|"browserback"}  state       state of the user ("loggedin", "anonymous", "browserback",
                     *                                                            session-id on int/test)
                     * @param {string|null}                           guid_device used to retrieve correct SSO server via
                     *                                                            ApiClient::get_server_url_using_guid($guid, $ssoEnvironment)
                     *                                                            null in case of anonymous
                     * @param {string|null}                           ssoenv      environment of the used SSO server ("int", "test", "prod")
                     *                                                            null in case of anonymous
                     * @param {string|null}                           session     user session on NON prod-env, null in case of anonymous
                     */
                },
                {
                    key: 'onUnifiedLoginSuccess',
                    value: function onUnifiedLoginSuccess(
                        userlogin,
                        phone,
                        email,
                        points,
                        logintype,
                        state,
                        guid_device,
                    ) {
                        var ssoenv = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
                        var session = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
                        this.unifiedLoginTriggered = false;

                        if (
                            userlogin !== null &&
                            typeof userlogin === 'string' &&
                            (userlogin === 'email' || userlogin === 'phone') &&
                            (phone === null || typeof phone === 'string') &&
                            (email === null || typeof email === 'string') &&
                            points !== null &&
                            typeof points === 'string' &&
                            (points === 'true' || points === 'false' || points === 'yes' || points === 'no') &&
                            (logintype === null ||
                                (typeof logintype === 'string' &&
                                    (logintype === 'login' || logintype === 'register'))) &&
                            state !== null &&
                            typeof state === 'string' &&
                            (state === 'loggedin' || state === 'anonymous' || state === 'browserback') &&
                            (guid_device === null || typeof guid_device === 'string') &&
                            (ssoenv === null ||
                                (typeof ssoenv === 'string' &&
                                    (ssoenv === 'int' || ssoenv === 'test' || ssoenv === 'prod')))
                        ) {
                            var ulObject = {
                                USERLOGIN: userlogin,
                                USERPHONE: phone,
                                USEREMAIL: email,
                                USERPOINTS: points,
                                LOGINTYPE: logintype,
                                STATE: state,
                                GUID_DEVICE: guid_device,
                                SSO_ENV: ssoenv,
                                SSO_SESSION: session,
                            };
                            window.dispatchEvent(
                                new CustomEvent('unified-login', {
                                    detail: _objectSpread(
                                        _objectSpread({}, ulObject),
                                        {},
                                        {
                                            ul: _objectSpread({}, ulObject),
                                        },
                                    ),
                                }),
                            );
                        } else {
                            this.onUnifiedLoginError();
                        }
                    },
                    /**
                     * Called by the app when there occurred an error during Unified Login
                     */
                },
                {
                    key: 'onUnifiedLoginError',
                    value: function onUnifiedLoginError() {
                        this.unifiedLoginTriggered = false;
                        var ulObject = {
                            STATE: 'anonymous',
                        };
                        window.dispatchEvent(
                            new CustomEvent('unified-login', {
                                detail: _objectSpread(
                                    _objectSpread({}, ulObject),
                                    {},
                                    {
                                        ul: _objectSpread({}, ulObject),
                                    },
                                ),
                            }),
                        );
                    },
                    /**
                     * Called by the app when there occurred an error during Unified Login
                     *
                     * @param {string|null} enteredPhone    phonenumber the user has entered
                     * @param {string|null} enteredEmail    email the user has entered
                     */
                },
                {
                    key: 'onUnifiedLoginCancel',
                    value: function onUnifiedLoginCancel(enteredPhone, enteredEmail) {
                        this.unifiedLoginTriggered = false;
                        var ulObject = {
                            STATE: 'browserback',
                            USERPHONE: enteredPhone,
                            USEREMAIL: enteredEmail,
                        };
                        window.dispatchEvent(
                            new CustomEvent('unified-login', {
                                detail: _objectSpread(
                                    _objectSpread({}, ulObject),
                                    {},
                                    {
                                        ul: _objectSpread({}, ulObject),
                                    },
                                ),
                            }),
                        );
                    },
                    /**
                     * Called by the app in case support dialog was clicked
                     * Please use to register a handler {@link setSupportDialogHandler}
                     *
                     * @return {Boolean} true in case handled otherwise false
                     */
                },
                {
                    key: 'onSupportDialogTriggered',
                    value: function onSupportDialogTriggered() {
                        if (typeof this._supportDialogHandler === 'function') {
                            return this._supportDialogHandler();
                        }

                        return false;
                    },
                    /**
                     * Updates text and placeholder in the search bar
                     * @function C24App#setSearchBarText
                     *
                     * @param {string|null}     searchTerm
                     * @param {string|null}     searchPlaceholder
                     * @param {function|null}   completion          The callback for the result
                     */
                },
                {
                    key: 'setSearchBarText',
                    value: function setSearchBarText(searchTerm, searchPlaceholder, completion) {
                        // Set callback
                        this.setCallback('setSearchBarText', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'setSearchBarText',
                                searchTerm: searchTerm,
                                searchPlaceholder: searchPlaceholder,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.setSearchBarText(searchTerm, searchPlaceholder);
                        }
                    },
                    /**
                     * Callback from setSearchBarText
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'setSearchBarTextCompletion',
                    value: function setSearchBarTextCompletion(result, message) {
                        this.callback('setSearchBarText', result, message);
                    },
                    /**
                     * Increases the wishlist count by given value
                     * @function C24App#increaseWishlistCount
                     *
                     * @param {int}             value
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'increaseWishlistCount',
                    value: function increaseWishlistCount(value, completion) {
                        // Set callback
                        this.setCallback('increaseWishlistCount', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'increaseWishlistCount',
                                value: value,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.increaseWishlistCount(value);
                        }
                    },
                    /**
                     * Callback from increaseWishlistCount
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'increaseWishlistCountCompletion',
                    value: function increaseWishlistCountCompletion(result, message) {
                        this.callback('increaseWishlistCount', result, message);
                    },
                    /**
                     * Decreases the wishlist count by given value
                     * @function C24App#decreaseWishlistCount
                     *
                     * @param {int}             value
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'decreaseWishlistCount',
                    value: function decreaseWishlistCount(value, completion) {
                        // Set callback
                        this.setCallback('decreaseWishlistCount', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'decreaseWishlistCount',
                                value: value,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.decreaseWishlistCount(value);
                        }
                    },
                    /**
                     * Callback from decreaseWishlistCount
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'decreaseWishlistCountCompletion',
                    value: function decreaseWishlistCountCompletion(result, message) {
                        this.callback('decreaseWishlistCount', result, message);
                    },
                    /**
                     * Provides application camera permission status
                     * @function C24App#cameraPermissionStatus
                     *
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'cameraPermissionStatus',
                    value: function cameraPermissionStatus(completion) {
                        // Set callback
                        this.setCallback('cameraPermissionStatus', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'cameraPermissionStatus',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.cameraPermissionStatus();
                        }
                    },
                    /**
                     * Callback from cameraPermissionStatus
                     *
                     * @param {string}      result ('notDetermined' | 'authorized' | 'denied')
                     * 'notDetermined': permission request was not shown to the user yet
                     * 'enabled': user gave permission for the camera access
                     * 'disabled': user prohibited access to the camera
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'cameraPermissionStatusCompletion',
                    value: function cameraPermissionStatusCompletion(result, message) {
                        this.callback('cameraPermissionStatus', result, message);
                    },
                    /**
                     * Opens app permissions screen
                     * @function C24App#openAppPermissionsScreen
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'openAppPermissionsScreen',
                    value: function openAppPermissionsScreen(completion) {
                        // Set callback
                        this.setCallback('openAppPermissionsScreen', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'openAppPermissionsScreen',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.openAppPermissionsScreen();
                        }
                    },
                    /**
                     * Callback from openAppPermissionsScreen
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'openAppPermissionsScreenCompletion',
                    value: function openAppPermissionsScreenCompletion(result, message) {
                        this.callback('openAppPermissionsScreen', result, message);
                    },
                    /**
                     * Checks if plugin with given identifier is enabled
                     * @function C24App#isPluginEnabled
                     *
                     * @param {string}          pluginIdentifier
                     * @param {function|null}   completion          The callback for the result
                     */
                },
                {
                    key: 'isPluginEnabled',
                    value: function isPluginEnabled(pluginIdentifier, completion) {
                        // Set callback
                        this.setCallback('isPluginEnabled', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'isPluginEnabled',
                                pluginIdentifier: pluginIdentifier,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.isPluginEnabled(pluginIdentifier);
                        }
                    },
                    /**
                     * Callback from isPluginEnabled
                     *
                     * @param {boolean}     isEnabled   Indicates if plugin is enabled
                     * @param {string|null} message     A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'isPluginEnabledCompletion',
                    value: function isPluginEnabledCompletion(isEnabled, message) {
                        this.callback('isPluginEnabled', isEnabled, message);
                    },
                    /**
                     * This function triggers an update of the given data sources from the backend inside the app.
                     *
                     * @param {string[]}        values         The data sources that need to be updated. Possible values: { "alarms" }
                     * @param {function|null}   completion     The callback for the result
                     */
                },
                {
                    key: 'updateData',
                    value: function updateData(values, completion) {
                        this.setCallback('updateDataCompletion', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'updateData',
                                values: values,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.updateData(values);
                        }
                    },
                    /**
                     * Callback that will be called from the app.
                     * This result only reflects the result of the trigger but not the completion of the data sources themselves.
                     *
                     * @param {boolean}     success     Will be true if trigger has been received successfully
                     * @param {string|null} message     Will provide additional information in Alpha apps if result is false
                     */
                },
                {
                    key: 'updateDataCompletion',
                    value: function updateDataCompletion(success, message) {
                        this.callback('updateDataCompletion', success, message);
                    },
                    /**
                     * This function updates the inbox count displayed in the app.
                     *
                     * @param {number|null}     count       New inbox count as integer
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'updateInboxCount',
                    value: function updateInboxCount(count, completion) {
                        this.setCallback('updateInboxCountCompletion', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'updateInboxCount',
                                count: count,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.updateInboxCount(count);
                        }
                    },
                    /**
                     * Callback that will be called from the app.
                     * This result only reflects the result of the trigger but not the completion of the data sources themselves.
                     *
                     * @param {boolean}     success     Will be true if trigger has been received successfully
                     * @param {string|null} message     Will provide additional information in Alpha apps if result is false
                     */
                },
                {
                    key: 'updateInboxCountCompletion',
                    value: function updateInboxCountCompletion(success, message) {
                        this.callback('updateDataCompletion', success, message);
                    },
                    /**
                     * This function gets the Matomo visitor ID used by the app.
                     * @function C24App#getMatomoVisitorID
                     *
                     * @param {function|null}   completion  The callback for the result
                     */
                },
                {
                    key: 'getMatomoVisitorID',
                    value: function getMatomoVisitorID(completion) {
                        this.setCallback('getMatomoVisitorIDCompletion', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'getMatomoVisitorID',
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.getMatomoVisitorID();
                        }
                    },
                    /**
                     * Completion for getMatomoVisitorID
                     *
                     * @param {string|null} visitorID   Will be true if trigger has been received successfully
                     * @param {string|null} message     Will provide additional information in Alpha apps if result is false
                     */
                },
                {
                    key: 'getMatomoVisitorIDCompletion',
                    value: function getMatomoVisitorIDCompletion(visitorID, message) {
                        this.callback('getMatomoVisitorIDCompletion', visitorID, message);
                    },
                    /**
                     * Called by the App in error cases that cannot be assigned to a concrete completion method.
                     *
                     * @param result
                     */
                },
                {
                    key: 'onError',
                    value: function onError(result) {
                        // Handle Unified Login errors
                        if (this.unifiedLoginTriggered) {
                            this.unifiedLoginTriggered = false; // Only iOS needs to be handled separately

                            if (this.isiOSBridgeAvailable()) {
                                this.onUnifiedLoginError();
                            }

                            return;
                        }

                        if (this._errorHandler != null) {
                            this._errorHandler(result);
                        }
                    },
                    /**
                     * Triggers profile account login credential edit dialog
                     *
                     * The currently available values for the dialog are:
                     * - value (string) email or phone
                     *
                     * @function C24App#triggerPushPermissionDialog
                     *
                     * @param {value}                         value             Options for Edit Dialog
                     * @param {function|null}                 completion        The callback for the result
                     *
                     */
                },
                {
                    key: 'triggerProfileAccountLoginCredentialEditDialog',
                    value: function triggerProfileAccountLoginCredentialEditDialog(value, completion) {
                        // Set callback
                        this.setCallback('triggerProfileAccountLoginCredentialEditDialog', completion);

                        if (window.C24App.isiOSBridgeAvailable()) {
                            // Invoke bridge method
                            window.webkit.messageHandlers.appBridge.postMessage({
                                method: 'triggerProfileAccountLoginCredentialEditDialog',
                                value: value,
                            });
                        } else if (window.C24App.isAndroidBridgeAvailable()) {
                            appBridge.triggerProfileAccountLoginCredentialEditDialog(value);
                        }
                    },
                    /**
                     * Callback from triggerProfileAccountLoginCredentialEditDialog
                     *
                     * @param {boolean}     result
                     * @param {string|null} message A debug description. Only set in Alpha apps
                     */
                },
                {
                    key: 'triggerProfileAccountLoginCredentialEditDialogCompletion',
                    value: function triggerProfileAccountLoginCredentialEditDialogCompletion(result, message) {
                        this.callback('triggerProfileAccountLoginCredentialEditDialog', result, message);
                    },
                    /**
                     * Can be used to check if iOS Javascript bridge is available in this page
                     * @returns {boolean}
                     */
                },
                {
                    key: 'isiOSBridgeAvailable',
                    value: function isiOSBridgeAvailable() {
                        return (
                            window.webkit !== undefined &&
                            window.webkit.messageHandlers !== undefined &&
                            window.webkit.messageHandlers.appBridge !== undefined
                        );
                    },
                    /**
                     * Can be used to check if Android Javascript bridge is available in this page
                     * @returns {boolean}
                     */
                },
                {
                    key: 'isAndroidBridgeAvailable',
                    value: function isAndroidBridgeAvailable() {
                        return window.appBridge !== undefined;
                    },
                    /**************************
                     * INTERNALS
                     **************************/
                },
                {
                    key: 'setCallback',
                    value: function setCallback(method, callback) {
                        if (callback !== null) {
                            if (this._callbackMap == null) {
                                this._callbackMap = {};
                            }

                            this._callbackMap[method] = callback;
                        }
                    },
                },
                {
                    key: 'removeCallback',
                    value: function removeCallback(method) {
                        this._callbackMap[method] = null;
                    },
                },
                {
                    key: 'callback',
                    value: function callback(method, result, message) {
                        if (this._callbackMap != null) {
                            var callbackMethod = this._callbackMap[method];

                            if (typeof callbackMethod == 'function') {
                                this.removeCallback(method);
                                callbackMethod(result, message);
                            }
                        }
                    },
                },
            ]);

            return C24App;
        })();

        if (
            navigator.share === undefined &&
            window.C24App.isAndroidBridgeAvailable() &&
            appBridge.shareNative !== undefined &&
            appBridge.canShareNative !== undefined
        ) {
            navigator.share = function (data) {
                return appBridge.shareNative(JSON.stringify(data));
            };

            navigator.canShare = function (data) {
                return appBridge.canShareNative(JSON.stringify(data));
            };
        }
        window.Check24 = window.Check24 || {};

        window.Check24.loader = {
            configs: [],
            initialized: false,
            defaultConfigs: {
                chatty: {
                    jsType: 'text',
                    chattyVersion: '2.41',
                    currentVersion: null,
                    enabled: true,
                    env: 'prod',
                    deviceoutput: 'desktop',
                    chatbot: {
                        client: {
                            controlServerAddress: 'https://api.chat.check24.de',
                            chatFlowName: 'home.welcome',
                            chatFlowRelease: 'active',
                            chatFlowEntry: 'start_from_home',
                        },
                        contact: {
                            button: {
                                active: false,
                            },
                            layer: {
                                active: false,
                            },
                        },
                        env: 'prod',
                        activeStateSticky: true,
                        deviceoutput: 'desktop',
                    },
                    contact: {
                        button: {
                            active: false,
                        },
                        layer: {
                            active: false,
                        },
                    },
                },
            },
            storedConfigs: [],
            setHtml: function (data) {
                if (data && data.id && data.tagName) {
                    var ele = document.createElement(data.tagName);
                    ele.id = data.id;
                    document.body.appendChild(ele);
                } else {
                }
            },
            jsType: 'text',
            setJs: function (key, data) {
                if (data && data.src) {
                    if (typeof window.Check24.loader.configs[key] !== 'undefined') {
                        window.Check24.loader.configs[key]['loading'] = true;
                    }
                    var script = document.createElement('script');
                    script.src = data.src;
                    if (window.Check24.loader.jsType !== '' && window.Check24.loader.jsType !== 'text') {
                        script.type = window.Check24.loader.jsType;
                    }
                    script.onload = function () {
                        if (typeof window.Check24.loader.configs[key] !== 'undefined') {
                            window.Check24.loader.configs[key]['loading'] = false;
                        }
                        if (typeof data.callback == 'function') {
                            data.callback(data);
                        }
                    };
                    document.body.appendChild(script);
                } else {
                }
            },
            setCss: function (key, data) {
                if (data && data.src) {
                    var style = document.createElement('link');
                    style.rel = 'stylesheet';
                    style.type = 'text/css';
                    style.href = data.src;
                    style.onload = function () {
                        if (typeof data.callback == 'function') {
                            data.callback(data);
                        }
                    };
                    document.getElementsByTagName('head')[0].appendChild(style);
                } else {
                }
            },
            setConfig: function (key, config) {
                this.configs[key] = config;
            },
            loadConfig: function (key, config) {
                if (window.Check24.loader.configs[key] && !window.Check24.loader.configs[key]['loaded']) {
                    var js = config['js'],
                        css = config['css'],
                        html = config['html'];

                    window.Check24.loader.setHtml(html);

                    css.forEach(function (value) {
                        window.Check24.loader.setCss(key, value);
                    });

                    js.forEach(function (value) {
                        window.Check24.loader.setJs(key, value);
                    });

                    window.Check24.loader.configs[key]['loaded'] = true;
                } else {
                }
            },
            getEnvPrep: function (key) {
                if (key && key.env && key.env !== '' && key.env !== 'prod') {
                    return '-' + key.env;
                } else {
                    return '';
                }
            },
            contactLayerDefault: {
                openChatEvent: 'c24-chat-chatty-open',
                img: '',
                name: 'Sophie',
                title: 'Schnelle Hilfe, 24/7',
                subtitle: 'Ihre digitale Chat-Assistentin.',
                openChatText: 'Chat starten',
                contactLink: 'https://www.check24.de/unternehmen/kontakt/',
                contactLinkText: 'Weiter zum <span>Kundenservice</span>',
            },
            openTrigger: function (conf) {
                var openEvent = new CustomEvent(conf.openChatEvent, {
                    detail: {
                        origin: 'loader_layer',
                        action: 'openchat',
                    },
                });
                document.dispatchEvent(openEvent);
                window.Check24.loader.hideElements();
            },
            closeTrigger: function () {
                var openEvent = new CustomEvent('c24-chat-chatty-close', {
                    detail: {
                        origin: 'loader_layer',
                        action: 'openchat',
                    },
                });
                document.dispatchEvent(openEvent);
                window.Check24.loader.showElements();
            },
            checkConfig: function (config) {
                if (typeof config.type === 'undefined' || config.type === '') {
                }
                if (
                    config.type === 'chatty' &&
                    (typeof config.chattyVersion === 'undefined' || config.chattyVersion === '')
                ) {
                }
                window.Check24.loader.chatty.addJsType(config);
            },
            clickEventHandler: undefined,
            triggerChatbot: function (ele, config) {
                if (ele === null) {
                    return;
                }

                ele.removeEventListener('click', this.clickEventHandler);

                this.clickEventHandler = function (event) {
                    event.preventDefault();
                    window.Check24.loader.chatty.close();
                    window.Check24.loader.openChatbot(window.Check24.loader.storedConfigs[config.name]);
                };
                ele.addEventListener('click', this.clickEventHandler);
            },
            setContactLayer: function (config, chattyTrigger = false, callback) {
                window.Check24.loader.initialized = true;

                if (typeof window.Check24.contact !== 'undefined') {
                    window.Check24.contact.isContactLayerEnabled = false;
                }

                window.Check24.loader.checkConfig(config);
                window.Check24.loader.chatty.close();
                this.storedConfigs[config.name] = config;
                var conf = Object.assign({}, this.contactLayerDefault, config.contact.layer);
                var contactEntry = document.querySelector('.c24-contact');

                if (chattyTrigger) {
                    if (window.Check24.exists('.c24-contact')) {
                        window.Check24.loader.triggerChatbot(contactEntry, config);
                    }
                    window.Check24.loader.chatty.preloading(window.Check24.loader.storedConfigs[config.name]);
                }

                if (typeof callback === 'function') {
                    callback(conf);
                }
            },
            addChatbotButton: function (config, chattyTrigger = false, callback) {
                window.Check24.loader.checkConfig(config);
                window.Check24.loader.chatty.close();
                this.storedConfigs[config.name] = config;
                var conf = Object.assign({}, this.contactLayerDefault, config.contact.button),
                    wrapper = document.createElement('div'),
                    text = document.createElement('div');
                wrapper.setAttribute('class', 'c24-chatbot-button');
                text.setAttribute('class', 'c24-chatbot-button-text');

                text.innerHTML = 'Chat';
                wrapper.appendChild(text);

                var button = document.querySelector('.c24-chatbot-button');
                if (button) {
                    button.remove();
                }

                var body = document.querySelector('body');
                if (conf.hasOwnProperty('appendingele')) {
                    body = document.querySelector(conf.appendingele);
                }
                body.appendChild(wrapper);

                if (chattyTrigger) {
                    function triggerListener() {
                        window.Check24.loader.openChatbot(window.Check24.loader.storedConfigs[config.name]);
                    }
                    wrapper.removeEventListener('click', triggerListener, false);
                    wrapper.addEventListener('click', triggerListener, false);

                    window.Check24.loader.chatty.preloading(window.Check24.loader.storedConfigs[config.name]);
                }

                if (typeof callback === 'function') {
                    callback(conf);
                }
            },
            addChatbotElement: function (config, element, callback) {
                window.Check24.loader.checkConfig(config);
                this.storedConfigs[config.name] = config;
                var conf = Object.assign({}, this.contactLayerDefault, config.element);

                function triggerListener() {
                    window.Check24.loader.openChatbot(window.Check24.loader.storedConfigs[config.name]);
                }
                element.removeEventListener('click', triggerListener, false);
                element.addEventListener('click', triggerListener, false);

                window.Check24.loader.chatty.preloading(window.Check24.loader.storedConfigs[config.name]);

                if (typeof callback === 'function') {
                    callback(conf);
                }
            },
            openChatbot: function (config, callback) {
                if (['app', 'tabletapp'].includes(config.deviceoutput) && window.Check24.loader.useChatbotApp) {
                    window.Check24.loader.chatbotApp(config);
                    return;
                }

                this.storedConfigs[config.name] = config;
                window.Check24.loader.setCurrentChatbot(config);

                var conf = Object.assign({}, this.contactLayerDefault, config.element);

                if (config.type === 'chatty') {
                    if (config.onDemand && typeof window.Check24.loader.configs[config.name] === 'undefined') {
                        window.Check24.loader.chatty.init(config);
                    } else {
                        var configs = window.Check24.loader.configs;
                        if (
                            window.Check24.loader.chatty.currentConfig !== config.name ||
                            Object.keys(configs).length > 1
                        ) {
                            config.chatbot.active = true;
                            if (window.Check24.loader.chatty.assetsLoaded.includes(config.chattyVersion)) {
                                window.Check24.loader.chatty.close();
                                window.Check24.chat_chatty.init(config.chatbot);
                                window.Check24.loader.chatty.currentConfig = config.name;
                                window.Check24.loader.hideElements();
                            } else {
                                window.Check24.loader.chatty.init(config);
                            }
                        } else {
                            window.Check24.loader.openTrigger(conf);
                        }
                    }
                } else {
                    window.Check24.loader.openTrigger(conf);
                }

                if (typeof callback === 'function') {
                    callback(conf);
                }
            },
            hideElements: function () {
                var contactLayer = document.querySelector('.c24-contact-layer');
                if (contactLayer) {
                    contactLayer.style.visibility = 'hidden';
                    window.Check24.removeClass('.c24-contact', 'open');
                }
                window.Check24.hide('.c24-chatbot-button');
            },
            showElements: function () {
                window.Check24.show('.c24-chatbot-button');
            },
            useChatbotApp: false,
            chatbotApp: function (config) {
                var chatbotConfig = config.chatbot;
                if (!chatbotConfig.hasOwnProperty('client')) {
                    return;
                }
                var client = chatbotConfig.client;
                window.C24App.triggerChattyWithOptions({
                    chatFlowName: client.chatFlowName || '',
                    chatFlowEntry: client.chatFlowEntry || '',
                    chatFlowRelease: client.chatFlowRelease || '',
                    clientDetails: client.clientDetails || {},
                    presentationType: client.presentationType || null,
                    sheetState: client.sheetState || null,
                });
            },
            useUrlCheck: true,
            urlCheck: function (key, value) {
                if (!window.Check24.loader.useUrlCheck) {
                    return false;
                }
                try {
                    const params = new Proxy(new URLSearchParams(window.location.search), {
                        get: (searchParams, prop) => searchParams.get(prop),
                    });
                    return params[key] === value;
                } catch (e) {
                    return false;
                }
            },
            setCurrentChatbot: function (config) {
                try {
                    if (config.chatbot.activeStateSticky === true) {
                        sessionStorage.setItem('c24-current-chatbot', config.name);
                    } else {
                        sessionStorage.removeItem('c24-current-chatbot');
                    }
                } catch (e) {
                    sessionStorage.removeItem('c24-current-chatbot');
                }
            },
            reset: {
                configs: function (configKey = null) {
                    if (configKey) {
                        delete window.Check24.loader.configs[configKey];
                    } else {
                        window.Check24.loader.configs = [];
                    }
                },
            },
            chatty: {
                bcVersion: '2023-2-7',
                init: function (config, open = true, callback) {
                    window.Check24.loader.chatty.listener(config, open);

                    if (typeof callback === 'function') {
                        callback(config);
                    }
                },
                addJsType: function (config) {
                    if (typeof config.jsType !== 'undefined') {
                        window.Check24.loader.jsType = config.jsType;
                    }
                },
                checkActive: true,
                checkActiveChatty: function () {
                    var data = JSON.parse(sessionStorage.getItem('c24-chat-assistant'));
                    if (!window.Check24.loader.chatty.checkActive || (data && !data.active)) {
                        return false;
                    }
                    return true;
                },
                usePreloading: true,
                preloaded: false,
                preloading: function (config) {
                    try {
                        var configs = window.Check24.loader.storedConfigs;
                        var active = window.Check24.loader.chatty.checkActiveChatty();
                        var current = sessionStorage.getItem('c24-current-chatbot');
                        if (
                            window.Check24.loader.chatty.usePreloading &&
                            !window.Check24.loader.chatty.preloaded &&
                            config.type === 'chatty' &&
                            ((active && configs.hasOwnProperty(current)) ||
                                window.Check24.loader.urlCheck('showchat', '1'))
                        ) {
                            var configuration =
                                current !== null && configs.hasOwnProperty(current) ? configs[current] : config;
                            window.Check24.loader.chatty.preloaded = true;
                            window.Check24.loader.chatty.init(configuration);
                            window.Check24.loader.hideElements();
                        }
                    } catch (e) {}
                },
                open: function () {
                    setTimeout(function () {
                        var openEvent = new CustomEvent('c24-chat-chatty-open', {
                            detail: {
                                origin: 'loader_button',
                                action: 'openchat',
                            },
                        });
                        document.dispatchEvent(openEvent);
                        window.Check24.loader.hideElements();
                    }, 50);
                },
                close: function () {
                    var closeEvent = new CustomEvent('c24-chat-chatty-close', {
                        detail: {
                            origin: 'loader',
                            action: 'closechat',
                        },
                    });
                    document.dispatchEvent(closeEvent);
                    window.Check24.loader.showElements();
                },
                assetsLoaded: [],
                addAssetLoaded: function (version) {
                    if (version !== '') {
                        window.Check24.loader.chatty.assetsLoaded.push(version);
                    }
                },
                chattyAssetDomain: 'https://frontend.chat.check24.de/',
                getChattyAssetConfig: function (config, callback) {
                    var version = window.Check24.loader.defaultConfigs.chatty.currentVersion
                        ? window.Check24.loader.defaultConfigs.chatty.currentVersion
                        : window.Check24.loader.defaultConfigs.chatty.chattyVersion;
                    if (config && config.chattyVersion && config.chattyVersion !== '') {
                        version = config.chattyVersion;
                    }
                    var queryParams = '';
                    var chattyVersionOverride = window.Check24.getCookie('__chattyVersion');
                    if (!!chattyVersionOverride) {
                        queryParams = '?__chattyVersion=' + encodeURIComponent(chattyVersionOverride);
                    }
                    var baseUri = window.Check24.loader.chatty.chattyAssetDomain + version + '/';
                    var assetsConfig = {
                        js: [
                            {
                                id: 'chatty_js',
                                src: baseUri + 'assets/src.f69400ca.js' + queryParams,
                                callback: function () {
                                    var loadEvent = new CustomEvent('chatty-assets-loaded-' + version, {
                                        detail: {
                                            origin: 'loader',
                                            action: 'assetsloaded',
                                            config: config.chatbot,
                                        },
                                    });
                                    window.dispatchEvent(loadEvent);
                                },
                            },
                        ],
                        css: [
                            {
                                id: 'chatty_css',
                                src: baseUri + 'assets/src.f69400ca.css' + queryParams,
                                callback: function () {},
                            },
                        ],
                        html: {
                            tagName: 'div',
                            id: 'c24-chatbot',
                        },
                        init: config.init ? config.init : null,
                    };

                    if (typeof callback === 'function') {
                        callback(config.name, assetsConfig);
                    } else {
                        window.Check24.loader.setConfig(config.name, assetsConfig);
                        window.Check24.loader.loadConfig(config.name, assetsConfig);
                    }
                },
                useVersionGetter: false,
                chattyVersionEp: '9dd6d2c3fe4f2d40451w9a867408ec85',
                getChattyVersion: function (callback, config, callbackError, timeout, callbackTimeout) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            var responseData = this.responseText;
                            window.Check24.loader.defaultConfigs.chatty.chattyVersion = responseData;
                            window.Check24.loader.defaultConfigs.chatty.loadedversion = responseData;
                            if (typeof callback === 'function') {
                                callback(config);
                            }
                        } else {
                            if (typeof callbackError === 'function') {
                                window.Check24.loader.defaultConfigs.chatty.enabled = false;
                                callbackError();
                            }
                        }
                    };

                    xhr.onerror = function () {
                        if (typeof callbackError === 'function') {
                            window.Check24.loader.defaultConfigs.chatty.enabled = false;
                            callbackError();
                        }
                    };

                    if (timeout) {
                        xhr.timeout = timeout;
                        xhr.ontimeout = function (e) {
                            if (typeof callbackTimeout === 'function') {
                                callbackTimeout(e);
                            }
                        };
                    }
                    var versionEp =
                        'https://chatty.check24' +
                        window.Check24.loader.getEnvPrep(config) +
                        '.de/' +
                        window.Check24.loader.chatty.chattyVersionEp;

                    xhr.open('GET', versionEp, true);
                    xhr.send();
                },
                currentConfig: '',
                listenerInitilized: false,
                listener: function (config, open) {
                    if (!window.Check24.loader.chatty.listenerInitilized) {
                        window.Check24.loader.chatty.listenerInitilized = true;

                        window.addEventListener(
                            'c24-chatty-close',
                            function (e) {
                                try {
                                    if (e.detail.chatty.checkFeedback === true) {
                                        window.Check24.hide('.c24-chatbot-button');
                                    } else {
                                        window.Check24.show('.c24-chatbot-button');
                                    }
                                } catch (e) {
                                    window.Check24.show('.c24-chatbot-button');
                                }
                            },
                            false,
                        );

                        window.addEventListener(
                            'c24-chatty-connection-info',
                            function (e) {
                                try {
                                    var conf = window.Check24.loader.storedConfigs[e.detail.chatty.configname];

                                    if (window.Check24.loader.chatty.checkActiveChatty()) {
                                        conf.chatbot.active = true;
                                    } else {
                                        conf.chatbot.active = false;
                                    }

                                    if (typeof conf.chatbot.client.clientDetails === 'undefined') {
                                        conf.chatbot.client.clientDetails = {};
                                    }
                                    conf.chatbot.client.clientDetails.connectionInfoDetails =
                                        e.detail.chatty.connectionInfoDetails;
                                    window.Check24.loader.storedConfigs[e.detail.chatty.configname] = conf;
                                    window.Check24.loader.setCurrentChatbot(conf);
                                    window.Check24.loader.chatty.close();
                                    window.Check24.chat_chatty.init(conf.chatbot);
                                    window.Check24.loader.chatty.currentConfig = e.detail.chatty.configname;
                                    window.Check24.loader.configs[e.detail.chatty.configname]['init'] = true;
                                } catch (e) {}
                            },
                            false,
                        );
                    }

                    var configs = window.Check24.loader.configs;
                    if (configs.hasOwnProperty(config.name)) {
                        window.Check24.loader.chatty.currentConfig = config.name;
                        return;
                    }
                    window.Check24.loader.setConfig(config.name, config);
                    if (!window.Check24.loader.chatty.assetsLoaded.includes(config.chattyVersion)) {
                        window.addEventListener(
                            'chatty-assets-loaded-' + config.chattyVersion,
                            function (e) {
                                var chattyConfig = e.detail.config;
                                if (open) {
                                    chattyConfig.active = true;
                                    window.Check24.loader.hideElements();
                                }
                                window.Check24.chat_chatty.init(chattyConfig);
                                window.Check24.loader.chatty.currentConfig = config.name;
                                window.Check24.loader.configs[config.name]['init'] = true;
                                window.Check24.loader.chatty.addAssetLoaded(config.chattyVersion);
                            },
                            false,
                        );

                        if (window.Check24.loader.chatty.useVersionGetter) {
                            window.Check24.loader.chatty.getChattyVersion(
                                window.Check24.loader.chatty.getChattyAssetConfig,
                                config,
                            );
                        } else {
                            window.Check24.loader.chatty.getChattyAssetConfig(config);
                        }
                    } else {
                        if (open) {
                            config.chatbot.active = true;
                            window.Check24.loader.hideElements();
                        }
                        window.Check24.loader.chatty.close();
                        window.Check24.chat_chatty.init(config.chatbot);
                        window.Check24.loader.chatty.currentConfig = config.name;
                        window.Check24.loader.configs[config.name]['init'] = true;
                    }
                },
            },
        };
        window.Check24 = window.Check24 || {};

        window.Check24.xppset = {
            amount: 3,
            domain: '.check24.de',
            getValues: function () {
                var val = window.Check24.getCookie('xppset');
                var xppset = [];

                if (val) {
                    xppset = [val];
                    if (val.indexOf(',')) {
                        xppset = val.split(',');
                    }
                }
                return xppset;
            },
            getExpireDate: function () {
                var myDate = new Date();
                myDate.setMonth(myDate.getMonth() + 3);

                return myDate;
            },
            setCookie: function (xppsetOutput) {
                var myDate = 'Thu, 01 Jan 1970 00:00:01 GMT';

                if (xppsetOutput.length) {
                    myDate = window.Check24.xppset.getExpireDate();
                }
                document.cookie =
                    'xppset=' +
                    xppsetOutput.join(',') +
                    '; expires=' +
                    myDate +
                    '; domain=' +
                    window.Check24.xppset.domain +
                    '; path=/; SameSite=lax';
            },
            addProduct: function (product) {
                if (product) {
                    var xppset = window.Check24.xppset.getValues();

                    var index = xppset.indexOf(product);
                    if (index !== -1) {
                        xppset.splice(index, 1);
                    }

                    var xppsetOutput = xppset.splice(0, window.Check24.xppset.amount - 1);
                    xppsetOutput.unshift(product);

                    window.Check24.xppset.setCookie(xppsetOutput);
                }
            },
            removeProduct: function (product) {
                if (product) {
                    var xppset = window.Check24.xppset.getValues();
                    if (xppset.length && xppset.indexOf(product) !== -1) {
                        xppset.splice(xppset.indexOf(product), 1);
                        window.Check24.xppset.setCookie(xppset);
                    }
                }
            },
        };

        window.dispatchEvent(new Event('wireframe-loaded-custom-event'));
        window.isWireframeLoaded = true;
        if (isCheck24Test) {
            window.Check24.uliloginlayer.config.env = 'test';
        }

        var settings = {};
    }, []);

    // enable search bar on S0
    React.useEffect(() => {
        if (props.deviceoutput.includes('app')) {
            return;
        }

        const handleSearch = () => {
            window.Check24.hitsSearch.actualSearchString = '';
            window.Check24.hitsSearch.userActualSearchString = '';
            window.Check24.hitsSearch.searchElement.value = '';
            window.Check24.hitsSearch.config.params.items = [];
            window.Check24.hitsSearch.removeSuggestContainter();
            const isSearchOpen = window.Check24.hasClass('.c24-search-icon', 'open');
            if (props.layoutId?.includes('S0') !== isSearchOpen) {
                if (isSearchOpen) {
                    window.Check24.search.restoreSlimSearch();
                    return;
                }
                window.Check24.addClass('.c24-search-icon', 'open');
                window.Check24.show(['.c24-search', '.c24-search-corner', '.c24-search-content']);
            }
        };
        window.addEventListener('pageshow', handleSearch);
        window.addEventListener('pagehide', handleSearch);
        routerEvents.on('routeChangeComplete', handleSearch);
        if (window.isWireframeLoaded) {
            handleSearch();
        } else {
            window.addEventListener('wireframe-loaded-custom-event', handleSearch);
        }
        return () => {
            window.removeEventListener('pageshow', handleSearch);
            window.removeEventListener('pagehide', handleSearch);
            routerEvents.off('routeChangeComplete', handleSearch);
            window.removeEventListener('wireframe-loaded-custom-event', handleSearch);
        };
    }, [props.layoutId]);

    return null;
}
